(function (window, angular, undefined) {'use strict';

var app = angular.module('app', [
  'ngSanitize',
  'ngMessages',
  'ngTouch',
  'ngAnimate',
  'ui.router',
  'ui.bootstrap',
  'ngS3upload',
  'ui.bootstrap-slider',
  'ui.mask',
  'validation.match',
  'angular-table',
  'angulartics',
  'angulartics.google.analytics',
  'angular-intro'
]);

//app.factory('PendingModerationInterceptor', function ($q, $injector) {
//  return {
//    responseError: function (rejection) {
//      var $popup = $injector.get('$popup');
//      var $timeout = $injector.get('$timeout');
//      if (_.get(rejection, 'data.name') === 'RM_Moderation') {
//        $timeout(function () {
//          $popup('prompt', { message: 'Your account is still pending approval,<br/>please check back later' });
//        });
//      }
//      return $q.reject(rejection);
//    }
//  };
//});

//app.config(function ($httpProvider) {
//  $httpProvider.interceptors.push('PendingModerationInterceptor');
//});

app.config(function ($locationProvider, $anchorScrollProvider, $animateProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $anchorScrollProvider.disableAutoScrolling();
  $animateProvider.classNameFilter(/ng-animated/);
});

app.run(function ($rootScope, $anchorScroll) {
  $rootScope.$on('$stateChangeSuccess', $anchorScroll);
});

angular.element(document).ready(function () {
  angular.bootstrap(document, ['app']);
});

'use strict';

app.filter('duration', function () {
  return function (value) {
    if (!value || value < 0) {
      return '0 min';
    }
    var h = Math.floor(value / 60);
    var m = value % 60;
    var hs = (h === 0) ? '' : (h === 1) ? '1 hour' : h + ' hours';
    var ms = (m === 0) ? '' : ' ' + m + ' mins';
    return (hs + ms);
  };
});

'use strict';

_([
  ['map', 'collect'],
  ['reduce', 'inject', 'foldl'],
  ['reduceRight', 'foldr'],
  ['find', 'detect'],
  ['select'/*, 'filter'*/], // leave 'filter' with angular implementation
  ['where'],
  ['findWhere'],
  ['reject'],
  ['invoke'],
  ['pluck'],
  ['max'],
  ['min'],
  ['sortBy'],
  ['groupBy'],
  ['countBy'],
  ['shuffle'],
  ['toArray'],
  ['size'],
  ['first', 'head', 'take'],
  ['initial'],
  ['last'],
  ['rest', 'tail', 'drop'],
  ['compact'],
  ['flatten'],
  ['without'],
  ['union'],
  ['intersection'],
  ['difference'],
  ['uniq', 'unique'],
  ['zip'],
  ['object'],
  ['indexOf'],
  ['lastIndexOf'],
  ['sortedIndex'],
  ['keys'],
  ['values'],
  ['pairs'],
  ['invert'],
  ['functions', 'methods'],
  ['pick'],
  ['omit'],
  ['parseInt'],
  ['escape'],
  ['unescape'],
  ['result'],
  ['template'],
  ['capitalize']
]).each(function (filters) {
  var factory = function () {
    return _.bind(_[filters[0]], _);
  };
  _(filters).each(function (filter) {
    app.filter(filter, factory);
  }).value();
}).value();

app.run(function ($window, $rootScope) {
  $rootScope._ = $window._;
});

'use strict';

app.filter('progress', function () {
  return function (value, total) {
    return Math.round(value / (total || 1) * 100) + '%';
  };
});

'use strict';

app.filter('timestamp', function () {
  function timestamp (value) {
    var delta = Date.now() - Date.parse(value);
    var seconds  = Math.floor(delta / 1000);
    var minutes  = Math.floor(seconds / 60);
    var hours    = Math.floor(minutes / 60);
    var days     = Math.floor(hours / 24);
    var weeks    = Math.floor(days / 7);
    var months   = Math.floor(days / 30);
    return (seconds < 45) ? 'few moments ago'
      : (seconds < 90) ? 'a minute ago'
      : (minutes < 45) ? minutes + ' minutes ago'
      : (minutes < 90) ? 'an hour ago'
      : (hours < 22)   ? hours + ' hours ago'
      : (hours < 36)   ? 'a day ago'
      : (days < 7)     ? days + ' days ago'
      : (weeks < 2)    ? 'a week ago'
      : (weeks < 4)    ? weeks + ' weeks ago'
      : (months < 2)   ? 'a months ago'
      : (months < 12)  ? months + ' months ago'
      :                  'over a year ago';
  }
  timestamp.$stateful = true;
  return timestamp;
});

'use strict';
/*global _gaq:false */
/*global _fbq:false */

app.config(function ($analyticsProvider) {
  //disable automatic pageview tracking
  $analyticsProvider.virtualPageviews(false);
});

var facebookTrackingInitialized = false;
app.service('rmAnalytics', function ($rootScope, $log, $analytics, $timeout) {
  this.setInstance = function (instance) {
    if (!instance) {
      return console.warn('No valid instance passed to init analytics variables');
    }
    _gaq.push(['_setCustomVar',
      1,                   // This custom var is set to slot #1.  Required parameter.
      'instanceId',        // The name acts as a kind of category for the user activity.  Required parameter.
      instance._id, // This value of the custom variable.  Required parameter.
      2                    // Sets the scope to session-level.  Optional parameter.
    ]);
    _gaq.push(['_setAccount', instance.analyticsProfileID]);

    var fbPixelId = _.get(instance, 'analytics.fbPixelId');
    if (fbPixelId && !facebookTrackingInitialized) {
      _fbq.push(['addPixelId', fbPixelId]);
      _fbq.push(['track', 'PixelInitialized', {}]);
      facebookTrackingInitialized = true;
    }
  };
  this.setUser = function (user) {
    if (!user || !user._id) {
      _gaq.push(['_deleteCustomVar', 2]);
    } else {
      _gaq.push(['_setCustomVar',
        2,                   // This custom var is set to slot #1.  Required parameter.
        'userId',            // The name acts as a kind of category for the user activity.  Required parameter.
        user._id, // This value of the custom variable.  Required parameter.
        2                    // Sets the scope to session-level.  Optional parameter.
      ]);
    }
  };

  this.track = function (event) {
    switch (event) {
      case 'signup':
        if (_.get($rootScope, 'instance.slug') === 'learn') {
          //fbq('track', 'Lead');
          //fbq('track', 'ViewContent');
          window._fbq.push(['track', 'Lead']);
          window._fbq.push(['track', 'ViewContent']);
        }
        break;
    }
  };

  this.init = function () {
    $rootScope.$watch('user', this.setUser);
    $rootScope.$watch('instance', this.setInstance);

    $rootScope.$on('$stateChangeSuccess', function () {
      $timeout($analytics.pageTrack);
    });
  };
});

app.run(function (rmAnalytics) {
  rmAnalytics.init();
});

'use strict';

app.service('Api', function ($q, $timeout, $http, $location, $rootScope, $state, $stateParams) {

  var Api = this;

  Api.me = function () {
    return $http.get('/api/v1/me')
      .then(_.property('data'))
      .catch(_.constant({}))
      .then(function (user) {
        $rootScope.user = user;
        user.flowPassed = _.get(user, 'meta.profileCompleted', false) && user.persona;
      });
  };

  Api.instances = function () {
    return $http.get('/api/v1/instances')
      .then(_.property('data'))
      .then(function (instances) {
        $rootScope.instances = instances;
      });
  };

  Api.session = function () {
    return $q.all([
      Api.me(),
      Api.instances()
    ]);
  };

  Api.track = function (name, type, params, meta) {
    params = params || {};
    params.instanceId = $rootScope.instance._id;
    _.extend(params, $stateParams);
    var data = { name: name, type: type, params: params, meta: meta };

    return $http.post('/api/v1/me/history', data)
      .then(function (update) {
        _.merge($rootScope.user, update.data);
      });
  };

  Api.module = function (id) {
    return $http.get('/api/v1/me/modules/' + id)
      .then(_.property('data'));
  };

  Api.history = function (instance) {
    return $http.get('/api/v1/me/instance/' + instance._id + '/history')
      .then(_.property('data'));
  };

  var backUrl;

  var redirect = function () {
    backUrl = backUrl || $state.href('instance.app.dashboard');
    $timeout(function () {
      $location.replace().url(backUrl);
    }, 100);
  };

  Api.auth = function () {
    if (!$rootScope.user._id) {
      backUrl = $location.url();
      if (!_.startsWith(backUrl, '/app/')) {
        backUrl = '/app/';
      }
      return $q.reject({ status: 401 });
    }
  };

  Api.flow = function (state) {
    var user = $rootScope.user;
    var profile = 'instance.app.profile';
    var assessment = 'instance.app.assessmentQuiz';

    var go = function (target) {
      $timeout(function () {
        $state.go(target);
      });
      return $q.reject();
    };

    user.flowPassed = _.get(user, 'meta.profileCompleted', false) && user.persona;

    if (state == profile) { return; }
    if (!_.get(user, 'meta.profileCompleted', false)) {
      return go(profile);
    }

    if (state == assessment) { return; }
    if (!user.persona) {
      return go(assessment);
    }
  };

  Api.refresh = function () {
    return Api.me().then(redirect);
  };

  Api.login = function (userData) {
    return $http.post('/api/v1/auth', userData)
      .then(function (response) {
        $rootScope.user = response.data.data.user;
      })
      .then(redirect);
  };

  Api.logout = function () {
    return $http.post('/api/v1/auth/logout')
      .then(function () {
        $rootScope.user = {};
        $state.go('instance', {}, {reload: true});
      });
  };

});

'use strict';


app.run(function ($rootScope, $http) {
  $rootScope.debugTools = $rootScope.debugTools || {};
  $rootScope.debugTools.resetUserGuides = function () {
    $http.delete('/api/v1/debug/deleteUserGuides').then(function () {
      location.reload();
    });
  };
});

'use strict';

app.service('Documents', function ($q, $preloader, $http, $popup) {

  /**
   * @param doc @param doc {{ name: name, sourceType: 'inline', sourceParams: { instanceId: file.meta.instanceId, fileId : file._id } }}
   * @returns {Promise<result>}
   */
  var saveDoc = function (doc) {
    $preloader.show();
    return $http.post('/api/v1/me/documents', doc)
      .finally($preloader.hide)
      .then(_.property('data'));
  };

  var popup = function (documentNames) {
    if (!_.isArray(documentNames)) {
      documentNames = [documentNames];
    }
    return $popup('doc-save', { documentNames: documentNames});
  };

  /**
   * Save document and display `prompt` popup
   * @param doc
   * @returns {Promise<result>}
   */
  this.save = function (doc) {
    return saveDoc(doc)
      .then(function (result) {
        return popup(result.name)
          .then(_.constant(result));
      });
  };

  /**
   * Alias for Document.save, accepts an array of documents and resolves with array of results
   * @param docs
   * @returns {Promise<[results]>}
   */
  this.saveMultiple = function (docs) {
    return $q.all(_.map(docs, saveDoc))
      .then(function (results) {
        var documentNames = _.map(results, 'name');
        return popup(documentNames)
          .then(_.constant(results));
      });
  };

  /**
   * Remove document
   * @param id
   * @returns {*}
   */
  this.remove = function (id) {
    return $http.delete('/api/v1/me/documents/' + id);
  };
});

'use strict';

app.service('HistoryAction', function () {
  this.format = function (action) {
    action.meta = action.meta || {};
    switch (action.name) {
      case 'module.introduction':
        action.icon = 'complete-lesson';
        action.title = 'You completed the ' + action.meta.label + ' Module Intro.';
        break;
      case 'module.quiz':
        var isPre = action.params.quizType == 'pre';
        action.icon = isPre ? 'complete-prequiz' : 'complete-postquiz';
        action.title = 'You completed the ' + action.meta.label + (isPre ? ' Pre' : ' Post') + ' Quiz.';
        break;
      case 'module.recap':
        action.icon = 'complete-module-recap-viewing';
        action.title = 'You completed the ' + action.meta.label + '.';
        break;
      case 'module.congratulations':
        action.icon = 'complete-module-congrats';
        action.title = 'You completed the ' + action.meta.label + '.';
        break;
      case 'module.lesson.recap':
        action.icon = 'complete-lesson-recap';
        action.title = 'You completed the ' + action.meta.label + '.';
        break;
      case 'module.lesson.introduction':
        action.icon = 'complete-lesson';
        action.title = 'You completed the ' + action.meta.label + ' Lesson Goals.';
        break;
      case 'module.lesson.byte':
        action.icon = 'complete-learning-byte';
        action.title = 'You completed the ' + action.meta.label + ' Learning Byte.';
        break;
      case 'module.lesson':
        action.icon = 'complete-module-congrats-viewing';
        action.title = 'You completed the ' + action.meta.label + ' Lesson.';
        break;
      case 'module':
        action.icon = 'complete-module-congrats-viewing';
        action.title = 'You completed the ' + action.meta.label + ' Module.';
        break;
      case 'instance.assessment':
        action.icon = 'update-user-profile';
        action.title = 'Congrats! You completed the ' + action.meta.label + ' Assessment Quiz.';
        break;
      case 'user.profile':
        action.icon = 'complete-user-profile';
        action.title = action.type == 'pass' ? 'You completed your profile.' : 'You updated your profile.';
        break;
      case 'user.registered':
        action.icon = 'complete-user-profile';
        action.title = 'You have been successfully registered.';
        break;
    }
    return action;
  };
});

'use strict';

app.service('Leaderboard', function ($q, $http) {
  var BASE_URL = '/api/v1/instances';
  this.fetch = function (instanceId, params) {
    return $http.get(BASE_URL + '/' + instanceId + '/leaderboard', {params: params})
      .then(_.property('data'));
  };

  this.userRank = function (instanceId, userId) {
    return $http.get(BASE_URL + '/' + instanceId + '/leaderboard/' + userId)
      .then(_.property('data'));
  };
});

'use strict';

app.provider('$popup', function () {

  var popups = {};

  this.define = function (name, conf) {
    popups[name] = conf;
  };

  this.$get = function ($modal, $timeout, $rootScope) {
    return function (name, params) {
      var opts = popups[name](params || {});
      opts.scope = (this instanceof $rootScope.constructor) ? this : $rootScope;
      return $modal.open(opts).result.finally(function () {
        $('.modal:last').trigger('$animate:close');
        $timeout(function () {
          $('.modal-backdrop:last').trigger('$animate:close');
        }, 50, false);
      });
    };
  };

});

app.config(function ($popupProvider) {
  $popupProvider.define('prompt', function (params) {
    return /*@ngInject*/ {
      windowClass: 'prompt-modal',
      template: [
        '<div class="prompt">',
          '<div class="prompt-body" ng-bind-html="params.message"></div>',
          '<div class="prompt-footer">',
            '<button class="btn btn-go" ng-click="$dismiss()">{{ params.reject || "Ok" }}</button> ',
            '<button class="btn btn-active" ng-click="$close()" ng-if="params.resolve">{{ params.resolve }}</button>',
          '</div>',
        '</div>'
      ].join(''),
      controller: function ($scope) {
        $scope.params = params;
      }
    };
  });
});

app.config(function ($popupProvider) {
  $popupProvider.define('video', function (video) {
    return /*@ngInject*/ {
      windowClass: 'video-modal',
      template: '<div rm-video="video" autoplay="true"></div>',
      controller: function ($scope) {
        $scope.video = video;
      }
    };
  });
});

app.run(function ($rootScope, $modalStack) {
  $rootScope.$on('$locationChangeStart', function (event) {
    var modal = $modalStack.getTop();
    if (modal) {
      event.preventDefault();
      modal.key.dismiss();
    }
  });
});

app.run(function ($rootScope, $popup) {
  $rootScope.$popup = $popup;
});

'use strict';

app.service('$preloader', function () {
  var count = 0;
  this.state = function () {
    return !!count;
  };
  this.show = function () {
    count++;
  };
  this.hide = function () {
    count--;
  };
});

app.config(function ($provide) {
  $provide.decorator('$state', function ($delegate, $q, $document, $preloader) {
    var $state = $delegate;
    var transitionTo = $state.transitionTo;
    $state.transitionTo = function () {
      // console.log(_.cloneDeep(_.toArray(arguments)));
      var args = _.toArray(arguments);
      $document[0].activeElement.blur();
      $preloader.show();
      var transition = $q.when().then(function () {
        return transitionTo.apply($state, args);
      });
      return transition.finally($preloader.hide);
    };
    return $state;
  });
});

// app.run(function ($rootScope, $preloader) {
//   $rootScope.$on('$stateChangeStart', $preloader.show);
//   $rootScope.$on('$stateChangeError', $preloader.hide);
//   $rootScope.$on('$stateChangeSuccess', $preloader.hide);
//   $rootScope.$on('$stateChangeCancel', $preloader.hide);
// });

'use strict';

app
  .constant('social.config', {
    providers: {
      google: {
        name: 'google',
        url: '/api/v1/auth/google',
        popupOptions: { width: 452, height: 633 }
      },
      facebook: {
        name: 'facebook',
        url: '/api/v1/auth/facebook',
        popupOptions: { width: 580, height: 400 }
      },
      linkedin: {
        name: 'linkedin',
        url: '/api/v1/auth/linkedin',
        popupOptions: { width: 527, height: 582 }
      }
    }
  })
  .provider('$social', ['social.config', function (config) {
    angular.forEach(Object.keys(config.providers), function (provider) {
      this[provider] = function (params) {
        return angular.extend(config.providers[provider], params);
      };
    }, this);

    var oauth = function (params) {
      config.providers[params.name] = config.providers[params.name] || {};
      angular.extend(config.providers[params.name], params);
    };


    this.oauth2 = function (params) {
      oauth(params);
      config.providers[params.name].type = '2.0';
    };

    this.$get = [
      'social.oauth',
      function (oauth) {
        var $social = {};
        $social.authenticate = function (name, userData) {
          return oauth.authenticate(name, false, userData);
        };
        return $social;
      }];

  }])
  .factory('social.oauth', [
    '$q',
    '$http',
    'social.config',
    'social.Oauth2',
    function ($q, $http, config, Oauth2) {
      var oauth = {};
      oauth.authenticate = function (name, redirect, userData) {
        var provider = new Oauth2();
        return provider.open(config.providers[name], userData || {});
      };
      return oauth;
    }])
  .factory('social.Oauth2', [
    '$q',
    '$http',
    '$window',
    'social.popup',
    'social.utils',
    'social.config',
    function ($q, $http, $window, popup) {
      return function () {
        var defaults = {
          url: null,
          name: null,
          redirectUri: null,
          popupOptions: null
        };
        var oauth2 = {};
        oauth2.open = function (options) {
          angular.extend(defaults, options);
          var url = defaults.url;
          defaults.redirectUri = window.location.origin || window.location.protocol + '//' + window.location.host;
          return popup.open(url, defaults.popupOptions, defaults.redirectUri);
        };
        return oauth2;
      };
    }])
  .factory('social.popup', [
    '$q',
    '$interval',
    '$window',
    '$location',
    'social.config',
    'social.utils',
    '$log',
    function ($q, $interval, $window, $location, config, utils, $log) {
      var AUTH_RESULT_KEY = 'auth_result';
      var popupWindow = null;
      var popup = {};
      var polling;
      var deferred;
      popup.popupWindow = popupWindow;

      angular.element($window).on('storage', function listener (e) {

        if (e.key === AUTH_RESULT_KEY && e.newValue) {
          popupWindow.close();
          var result = getFromLocalStorage();
          $log.info('onstorage', result);
          if (result) {
            if (result.error) {
              deferred.reject({ error: result.error });
            } else {
              deferred.resolve(result);
            }
          }
        }
      });

      popup.open = function (url, options/*, redirectUri*/) {
        deferred = $q.defer();
        $interval.cancel(polling);
        var optionsString = popup.stringifyOptions(popup.prepareOptions(options || {}));
        popupWindow = window.open(url, '_blank', optionsString);
        if (popupWindow && popupWindow.focus) {
          popupWindow.focus();
        }
        if (!popupWindow) {
          deferred.reject({data: 'Provider Popup Blocked'});
          return deferred.promise;
        }
        polling = $interval(function () {
          if (!popupWindow || popupWindow.closed) {
            $log.info('Social window closed');
            deferred.resolve();
            $interval.cancel(polling);
          }
        }, 1000);
        return deferred.promise;
      };


      function getFromLocalStorage () {
        var authResponse = $window.localStorage.getItem(AUTH_RESULT_KEY);
        $window.localStorage.removeItem(AUTH_RESULT_KEY);
        $log.info('getFromLocalStorage', authResponse);
        return authResponse ? utils.parseURL(authResponse) : false;
      }

      popup.prepareOptions = function (options) {
        var width = options.width || 500;
        var height = options.height || 500;
        return angular.extend({
          width: width,
          height: height,
          left: $window.screenX + (($window.outerWidth - width) / 2),
          top: $window.screenY + (($window.outerHeight - height) / 2.5)
        }, options);
      };

      popup.stringifyOptions = function (options) {
        var parts = [];
        angular.forEach(options, function (value, key) {
          parts.push(key + '=' + value);
        });
        return parts.join(',');
      };

      return popup;
    }])
  .service('social.utils', function () {
    this.parseURL = function (url) {
      var parser = document.createElement('a');
      parser.href = url;
      var queryParams = parser.search.substring(1).replace(/\/$/, '');
      var hashParams = parser.hash.replace('_=_', '').substring(1).replace(/\/$/, '');
      var hash = this.parseQueryString(hashParams);
      var qs = this.parseQueryString(queryParams);
      angular.extend(qs, hash);
      return qs;
    };
    this.parseQueryString = function (keyValue) {
      var obj = {};
      var key;
      var value;
      angular.forEach((keyValue || '').split('&'), function (keyValue) {
        if (keyValue) {
          value = keyValue.split('=');
          key = decodeURIComponent(value[0]);
          obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
        }
      });
      return obj;
    };
  });

'use strict';

app.service('$viewport', function ($window, $rootScope) {

  var self = this;

  var calc = function () {
    var mobile = $window.innerWidth <= 767;
    var tablet = $window.innerWidth <= 979;
    self.isMobile = !!mobile;
    self.isTablet = tablet && !mobile;
    self.isDesktop = !tablet && !mobile;
    self.isLandscape = $window.innerWidth > $window.innerHeight;
  };

  this.init = function () {
    calc();
    angular.element($window).on('resize', _.debounce(function () {
      $rootScope.$apply(calc);
    }, 150));
    return self;
  };

});

app.run(function ($rootScope, $viewport) {
  $rootScope.$viewport = $viewport.init();
});

'use strict';

app.config(function ($stateProvider, $urlRouterProvider) {

  $stateProvider.state('instance.login', {
    url: 'login',
    controller: function ($rootScope, $state, $stateParams, $timeout, $popup) {
      $state.go('instance.page', { name: 'home' }).finally(function () {
        $timeout(function () {
          $popup('auth', { view: 'login' });
        }, 200);
      });
    }
  });

  $stateProvider.state('instance.signup', {
    url: 'signup',
    controller: function ($rootScope, $state, $stateParams, $timeout, $popup) {
      $state.go('instance.page', { name: 'home' }).finally(function () {
        $timeout(function () {
          $popup('auth', { view: 'signup-social' });
        }, 200);
      });
    }
  });

  $stateProvider.state('instance.forgotPassword', {
    url: 'forgot-password?token',
    controller: function ($rootScope, $state, $stateParams, $timeout, $popup) {
      $state.go('instance.page', { name: 'home' }).finally(function () {
        $timeout(function () {
          $popup('auth', { view: 'reset', token: $stateParams.token });
        }, 200);
      });
    }
  });

  $stateProvider.state('instance', {
    url: '^/',
    resolve: {
      instance: function ($rootScope) {
        $rootScope.instance = _.first($rootScope.instances);
        return $rootScope.instance;
      }
    },
    template: '<ui-view />',
    controller: function ($scope, $state, rmMacroService) {
      rmMacroService.set('instance', $scope.instance);
      if ($state.is('instance')) {
        if ($scope.user._id) {
          $state.go('.app.dashboard');
        } else {
          $state.go('.page', { name: 'home' });
        }
      }
    }
  });

  $stateProvider.state('instance.app', {
    url: 'app',
    // abstract: true,
    resolve: {
      auth: function (Api) {
        return Api.auth();
      }
    },
    template: '<img class="layout-banner" ng-if="instance.images.logo" ng-src="{{ instance.images.logo }}"><ui-view />'
  });

  $stateProvider.state('instance.app.logout', {
    onEnter: function (Api) {
      Api.logout();
    }
  });

  $stateProvider.state('instance.page', {
    url: 'pages/:name/',
    templateUrl: function (params) {
      var page = params.name;
      var pages = ['home', 'soon', 'terms', 'privacy'];
      if (!_.contains(pages, page)) { page = '404'; }
      return '/pages/' + page + '/' + page + '.html';
    }
  });

  $urlRouterProvider.otherwise(function ($injector) {
    var $state = $injector.get('$state');
    if (!$state.is('instance.page', { name: '404' })) {
      $state.go('instance.page', { name: '404' }, { location: false });
    }
  });

  $urlRouterProvider.deferIntercept();

});

app.run(function ($rootScope, $timeout, $state, $location, $urlRouter, Api) {

  var ready = false;
  $rootScope.$on('$locationChangeSuccess', function (event) {
    if (ready) { return; }
    event.preventDefault();
    Api.session().then(function () {
      ready = true;
      $urlRouter.sync();
    });
  });
  $urlRouter.listen();

  $rootScope.$on('$stateNotFound', function (event) {
    event.preventDefault();
    $state.go('instance.page', { name: '404' });
  });

  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
    if (error && error.status) {
      switch (error.status) {
        case 404:
          $state.go('instance.page', { name: '404' }, { location: false });
          break;
        case 401:
        case 403:
          $timeout(function () {
            $state.go('instance.page', { name: 'home' })
              .then(function () {
                $timeout(function () {
                  $rootScope.$popup('auth');
                }, 100);
              });
          }, 100);
          break;
      }
    }
  });

});

'use strict';

// extended ng-bind-html to include all custom elements and behavior
// TODO: we can use custom directive to compile html. Think about pros/cons
app.directive('ngBindHtml', function ($rootScope, $timeout, $compile, $location, $popup, rmModals) {
  return {
    priority: -100,
    link: function (scope, element, attrs) {

      var major = scope.$eval(attrs.rmModalMajorInlines);

      // watch to make it "live" in admin preview
      scope.$watch(attrs.ngBindHtml, function () {
        $timeout(function () {

          // first add links to "minor inline components"
          if (major) {
            var html = element.html();
            _(major.minors).filter({ type: 'inline' }).forEach(function (inline) {
              var phrase = _.escapeRegExp(inline.data.phrase);
              var anchor = '<a class="minor-inline" modal="' + (inline.href || '') + '">$&</a>';
              if (!phrase) { return; }
              html = html.replace(/(<.*?>)?([^<]+)(<.*?>)?/gi, function (match, p1, p2, p3) {
                return (p1 || '') + p2.replace(RegExp(phrase, 'gi'), anchor) + (p3 || '');
              });
            }).value();
            element.html(html);
          }

          // then make all user links to open in new window
          element.find('a').attr('target', '_blank');

          // then compile all macros, but not in admin
          if (!$rootScope.alc) {
            var macros = angular.element(element[0].querySelectorAll('.rm-macro'));
            _.forEach(macros, function ($macro) {
              $compile($macro)(scope);
            });
          }

        });
      });

      element.on('click', function (event) {
        var target = angular.element(event.target);

        // open pdf modal, but not in admin
        if (!scope.$root.alc) {
          if (target.hasClass('rm-file')) {
            var src = JSON.parse(target.attr('src'));
            $popup('pdf', { type: 'inline', src: src });
          }
        }

        // open inline component modal popover
        if (target.hasClass('minor-inline')) {
          var name = target.attr('modal');
          if (!name) { return; }
          rmModals.addModalLink(name, target);
          $timeout(function () {
            $location.hash(name);
          });
        }

      });

    }
  };
});

'use strict';

app.directive('rmAsideToggle', function ($document) {
  return function (scope, element) {
    var isOpen = false;
    var toggler = angular.element('<a class="aside-toggle icon icon-toggle"></a>');
    var toggle = function () {
      isOpen = !isOpen;
      toggler.toggleClass('icon-toggle', !isOpen);
      toggler.toggleClass('icon-close', isOpen);
      element.toggleClass('open', isOpen);
    };
    var hide = function () {
      isOpen = true;
      toggle();
    };
    element.prepend(toggler);
    toggler.on('click', toggle);
    scope.$on('$locationChangeSuccess', hide);
    var docClick = function (event) {
      if (element[0].contains(event.target)) { return; }
      hide();
    };
    $document.on('click', docClick);
    scope.$on('$destroy', function () {
      $document.off('click', docClick);
    });
  };
});

'use strict';

app.directive('rmAudio', function ($window, $interval, $timeout) {
  return {
    scope: {
      url: '=rmAudio'
    },
    templateUrl: '/app/directives/rm-audio/rm-audio.html',
    link: function (scope, element) {

      var audio;

      scope.$watch('url', function (url) {
        scope.canplay = false;
        scope.timer = '';
        if (!url) { return; }
        if (audio) { scope.pause(); }
        audio = new $window.Audio(url);
        audio.load();
        angular.element(audio)
          .on('canplay', function () {
            scope.canplay = true;
            update();
          })
          .on('ended', function () {
            scope.pause();
          })
          .on('progress', function () {
            if (loading || scope.canplay) { return; }
            scope.$apply(function () {
              loading = true;
              scope.timer = 'loading';
            });
          });
        $timeout(function () {
          scope.timer = scope.timer || 'tap to load';
        }, 300);
      });

      var loading = false;

      scope.tapToClick = function () {
        if (loading || scope.canplay) { return; }
        scope.$apply(function () {
          loading = true;
          scope.timer = 'loading';
        });
        audio.load();
      };

      var interval;

      scope.play = function () {
        if (!audio) { return; }
        audio.play();
        interval = $interval(update, 25, 0, false);
      };

      scope.pause = function () {
        if (!audio) { return; }
        audio.pause();
        $interval.cancel(interval);
        update();
      };

      scope.$on('$destroy', function () {
        scope.pause();
      });

      element.on('$destroy', function () {
        scope.pause();
      });

      var prev;

      function update () {
        var curr = {
          paused: audio.paused,
          progress: (audio.currentTime / audio.duration * 100).toFixed(1),
          timer: timeToString(audio.currentTime) + '/' + timeToString(audio.duration)
        };
        if (!angular.equals(prev, curr)) {
          prev = curr;
          angular.extend(scope, curr);
          if (!scope.$root.$$phase) {
            scope.$digest();
          }
        }
      }

      function timeToString (time) {
        var secs = time >> 0;
        var mins = secs / 60 >> 0;
        return mins + ':' + (secs % 60);
      }

    }
  };
});

'use strict';

app.directive('rmChartist', function () {
  /**
   * Replace chartist default point svg with the <circle> svg element
   * @param data
   * @returns {*}
   */
  var replacePoint = function (data) {
    var attrs = {
      cx: [data.x],
      cy: [data.y],
      r: [4], //radius
      //ct:value & ct:meta are the Chartist generated attributes, so let's copy them as well
      'ct:value': [data.value],
      'ct:meta': [data.meta]
    };
    var circle = new Chartist.Svg('circle', attrs, 'ct-circle');
    data.element.replace(circle);
    return angular.element(circle._node);
  };
  return {
    scope: {
      data: '=rmChartist',
      options: '=options'
    },
    link: function ($scope, $element) {
      var options = _.merge({ lineSmooth: false }, $scope.options);
      $element.addClass('ct-chart rm-chartist');
      var chart = new Chartist.Line($element[0], $scope.data, options);
      chart.on('draw', function (data) {
        if (data.type === 'point') {
          var $point = replacePoint(data);
          $point.on('mouseenter', function () {
            $scope.$emit('rm-chartist:point:mouseenter', data, this);
          });
          $point.on('mouseleave', function () {
            $scope.$emit('rm-chartist:point:mouseleave', data, this);
          });
        }
      });
      chart.on('created', function (data) {
        var divider = new Chartist.Svg('line', null, 'ct-label-divider', this, false);
        var offset =  data.axisY.axisLength + data.axisY.gridOffset + 20;
        divider.attr({ x1: '1%', y1: offset, x2: '99%', y2: offset });
        data.svg.append(divider);
      });
      $scope.$on('$destroy', function () {
        if (chart) {
          chart.detach();
        }
      });
    }
  };
});

'use strict';
/**
 * Add-on to rmChartist directive
 * Show the tooltip on hover on the chart points
 * It will set the $scope.point to yours scope, so you can access current selected point via "point" expression
 * Point object content: {value: 624, x: 381.3333333333333, y: 25.85714285714286, index: 4}
 * @example
 * <div rm-chartist="graph">
     <div rm-chartist-tooltip>
        Tooltip template content goes here.
        It will be transcluded, so you can access your's controller scope easily.
        <pre>{{point | json}}</pre>
     </div>
   </div>
 */
app.directive('rmChartistTooltip', function ($timeout, $window) {
  var HIDE_DELAY = 700;
  /**
   * fitRectangleToTarget
   * @param anchorPoint {{x: number, y: number}}
   * @param rectangleToFit {{width: number}}
   * @param targetRectange {{width: number}}
   * @returns {{left: number}}
   */
  var fitRectangleToTarget = function (anchorPoint, rectangleToFit, targetRectange) {
    // 20 is a magic number, don't touch :)
    var containerWidth = targetRectange.width;
    var targetWidth = rectangleToFit.width;
    var left = Math.max(anchorPoint.x, targetWidth / 2);
    if (left > (containerWidth - targetWidth / 2)) {
      left = containerWidth - targetWidth / 2;
    }
    return {
      left: left
    };
  };
  return {
    replace: true,
    transclude: true,
    templateUrl: '/app/directives/rm-chartist-tooltip/rm-chartist-tooltip.html',
    link: function ($scope, el) {
      // Tooltip pointer (arrow) element
      var $pointer = angular.element(el[0].querySelector('.rm-chartist-tooltip-pointer'));
      // Chart point element, is being set on mouseenter event
      var $pointEl;
      // Timeout ID
      var hideTimer;
      // Current chart point data
      $scope.point = null;
      var adjustTooltipPosition = function (pointPosition) {
        var containerRect = el.parent()[0].getBoundingClientRect();
        var tooltipRect = el[0].getBoundingClientRect();
        var tooltipPosition = fitRectangleToTarget(pointPosition, tooltipRect, containerRect);
        var pointerPositionX = (tooltipRect.width / 2 - $pointer[0].offsetWidth / 2) - (tooltipPosition.left - pointPosition.x);
        $pointer.css('left', pointerPositionX + 'px');
        el.css({
          top: pointPosition.y + 'px',
          left: tooltipPosition.left + 'px'
        });
      };
      // Hide tooltip
      var hide = function () {
        hideTimer = $timeout(function () {
          el.css('display', 'none');
          $scope.point = null;
          if ($pointEl) {
            $pointEl.removeClass('active');
          }
        }, HIDE_DELAY);
      };
      // Show tooltip
      var show = function (data) {
        el.css('display', 'block');
        adjustTooltipPosition(data);
      };
      el.on('mouseenter', function () {
        $timeout.cancel(hideTimer);
      });
      el.on('mouseleave', hide);
      $scope.$on('rm-chartist:point:mouseenter', function (event, data, target) {

        if ($pointEl && $pointEl !== target) {
          //if mouse hovered on new point - reset active state from old one
          $pointEl.removeClass('active');
        }

        $pointEl = angular.element(target).addClass('active');
        $timeout.cancel(hideTimer);
        $scope.point = data;

        //notify angular $digest cycle
        $timeout(function () {
          show(data);
        });
      });

      $scope.$on('rm-chartist:point:mouseleave', hide);
      angular.element($window).on('resize orientationchange', hide);
    }
  };
});

'use strict';

app.directive('rmDatepicker', function () {
  return {
    replace: true,
    scope: {
      model: '=rmDatepicker',
      required: '='
    },
    templateUrl: '/app/directives/rm-datepicker/rm-datepicker.html',
    controller: function ($scope) {
      $scope.open = function ($event) {
        $event.stopPropagation();
        $scope.isOpen = true;
      };
    }
  };
});

'use strict';

app.directive('rmGauge', function ($compile) {
  var svg = '<svg><path ng-attr-d="M 36 4 A 32 32 0 {{ flag }} 1 {{ x }} {{ y }}" /></svg>';
  return {
    scope: {
      value: '=rmGauge'
    },
    restrict: 'A',
    link: function (scope, element) {
      var dom = angular.element(svg);
      $compile(dom)(scope);
      element.addClass('rm-gauge').append(dom);
      scope.$watch('value', function (value) {
        value = value || 0;
        var angle = Math.PI * ( 1 / 2  - 2 * value / 100.01);
        scope.flag = value > 50 ? 1 : 0;
        scope.x = 36 + 32 * Math.cos(angle);
        scope.y = 36 - 32 * Math.sin(angle);
      });
    }
  };
});

'use strict';

app.service('rmGuide', function ($window, $location) {
  var key = function (id) {
    return $location.host() + '.tutorial.' + id;
  };
  this.isViewed = function (id) {
    return !!$window.localStorage.getItem(key(id));
  };
  this.markViewed = function (id) {
    return $window.localStorage.setItem(key(id), 'true');
  };
});

app.directive('rmGuide', function () {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      icon: '=',
      tutorial: '=rmGuide',
      onNotificationDismiss: '&',
      isOpen: '='
    },
    templateUrl: '/app/directives/rm-guide/rm-guide.html',
    link: function (scope, el) {
      scope.iconLoaded = false;
      var img = new Image();
      img.onload = function () {
        scope.$apply(function () {
          scope.iconLoaded = true;
        });
      };
      img.src = scope.icon;

      scope.notification = {
        isOpen: angular.isDefined(scope.isOpen) ? scope.isOpen : true
      };
      scope.docked = !scope.notification.isOpen;
      scope.dismissNotification = function () {
        scope.docked = true;
        $(el).find('.rm-guide-notification, .rm-guide-notification-arrow')
          .addClass('exit-animation')
          .one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
            $(this).removeClass('exit-animation');
            scope.$apply(function () {
              scope.notification.isOpen = false;
            });
          });
        scope.onNotificationDismiss(scope.tutorial);
      };
      scope.open = function () {
        if (scope.notification.isOpen) {
          return;
        }
        $(el).find('.rm-guide-notification, .rm-guide-notification-arrow')
          .addClass('enter-animation')
          .one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
            $(this).removeClass('enter-animation');
          });
        scope.notification.isOpen = true;
      };

      scope.toggleIcon = function () {
        scope.docked = !scope.docked;
        if (!scope.docked) {
          scope.open();
        } else {
          scope.notification.isOpen = false;
        }
      };
    }
  };
});

'use strict';

app.directive('rmIntroGuide', function ($viewport, $compile) {
  var template = _.template(
    '<div class="rm-intro-guide-step-title">${title}</div>' +
    '<div class="rm-intro-guide-step-body">${body}</div>'
  );
  function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();
    return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
  }
  function transformSteps ($scope, steps) {
    return _.map(steps, function (step) {
      step.position = $viewport.isMobile ?  'bottom' : step.position;
      switch (step.id) {
        //HACKS for tooltip position on different devices, for particular step
        case 'skillPoints':
          if ($viewport.isTablet) {
            step.position = 'bottom';
          }
          break;
        case 'lessonLook':
          if ($viewport.isMobile) {
            step.position = 'bottom-right-aligned';
          }
          break;
        case 'lessonIntroduction':
        case 'preQuiz':
          if ($viewport.isTablet) {
            step.position = 'right';
          }
          break;
      }
      return {
        element: '#guide-' + step.id,
        position: step.position,
        tooltipClass: 'rm-intro-guide-popup',
        intro: $compile(angular.element('<div>' + template(step) + '</div>'))($scope).html()
      };
    });
  }
  var defaultOptions = {
    steps: [],
    showStepNumbers: false,
    scrollToElement: false,
    exitOnOverlayClick: true,
    exitOnEsc: true,
    nextLabel: 'NEXT >',
    prevLabel: '< BACK',
    overlayOpacity: 0.6,
    skipLabel: 'Exit',
    doneLabel: 'NEXT >'
  };
  return {
    restrict: 'A',
    templateUrl: '/app/directives/rm-intro-guide/rm-intro-guide.html',
    scope: {
      tourOptions: '=rmIntroGuide',
      onCompleted: '&onGuideCompleted',
      onExit: '&onGuideExit',
      onGuideChange: '&onGuideChange'
    },
    controller: function ($scope, $timeout) {
      _.merge($scope.tourOptions, defaultOptions);
      $scope.tourOptions.steps = transformSteps($scope, $scope.tourOptions.steps);
      $scope.autostart = $scope.tourOptions.steps.length > 0;
      $scope.onChange = function () {
        var self = this;
        $timeout(function () {
          var $popup = angular.element(document.querySelector('.introjs-tooltipReferenceLayer'));
          var $arrow = angular.element(document.querySelector('.introjs-arrow'));
          $popup.toggleClass('rm-intro-guide-last', self._introItems.length - 1 === self._currentStep);
          $popup.toggleClass('rm-intro-guide-first', !self._currentStep);
          var $button = angular.element(document.querySelector('.introjs-skipbutton'));
          var $nextButton = angular.element(document.querySelector('.introjs-nextbutton'));
          var $prevButton = angular.element(document.querySelector('.introjs-prevbutton'));
          var $parent = angular.element(document.querySelector('.introjs-tooltipbuttons'));
          var $tooltip = angular.element(document.querySelector('.introjs-tooltip'));
          $button.removeAttr('href');
          $prevButton.removeAttr('href');
          $nextButton.removeAttr('href');
          $button.detach();
          $parent.append($button);
          var ANIMATION_TIME = 350;
          $timeout(function () {
            if (!isElementInViewport($tooltip[0])) {
              $tooltip[0].scrollIntoView();
              if ($tooltip[0].getBoundingClientRect().left < 0) {
                $tooltip.css('left', 0);
              }
            }
            var headerHeight = document.querySelector('.layout-header').getBoundingClientRect().height;
            if ($popup[0].getBoundingClientRect().top < (headerHeight * 2)) {
              window.scrollBy(0, -(headerHeight * 2));
            }
            if ($arrow.hasClass('left-bottom') || $arrow.hasClass('right-bottom')) {
              $popup.css('top', (parseInt($popup.css('top'), 10) + 10) + 'px');
            }
          }, ANIMATION_TIME);
        });
      };
      /*
      $scope.ExitEvent = function (scope) {
        console.log("Exit Event called");
      };
      $scope.ChangeEvent = function (targetElement, scope) {
        console.log("Change Event called");
        console.log(targetElement);  //The target element
        console.log(this);  //The IntroJS object
      };


      $scope.BeforeChangeEvent = function (targetElement, scope) {
        console.log("Before Change Event called");
        console.log(targetElement);
      };

      $scope.AfterChangeEvent = function (targetElement, scope) {
        console.log("After Change Event called");
        console.log(targetElement);
      };*/

    }
  };
});

'use strict';

app.service('rmMacroService', function () {
  //TODO think about better way to resolve deps
  var data = {};
  this.get = function (key) {
    return key ? data[key] : data;
  };
  this.set = function (key, val) {
    data[key] = val;
    return this;
  };
});

app.directive('rmMacro', function () {
  //TODO reuse from admin?
  var load = function ($el) {
    var data = $el.attr('src') || '{}';
    try {
      data = JSON.parse(data);
    } catch (e) {
      console.err('invalid json in the macro saved state');
      data = {};
    }
    return data;
  };

  return {
    restrict: 'C',
    scope: {},
    controller: function ($scope, $element, $rootScope, rmMacroService) {
      var macro = load($element);
      var evalResult = $scope.$eval(macro.key, {
        user: $rootScope.user,
        instance: rmMacroService.get('instance'),
        module: rmMacroService.get('module')
      }) + '';
      switch (macro.mode) {
        case 'insert':
          $element.replaceWith(evalResult);
          break;
        case 'replace':
          var value = _.find(macro.replaceValues, function (val) {
            return val.original == evalResult;
          });
          if (value) {
            $element.replaceWith(value.replacement);
          }
          break;
      }
    }
  };
});

'use strict';

app.config(function ($provide) {
  $provide.decorator('$browser', function ($delegate) {
    var nativeUrl = $delegate.url;
    $delegate.url = function (url, replace, state) {
      if (!url) {
        return nativeUrl(url, replace, state).replace(/(#.+)|#$/, '$1');
      } else {
        return nativeUrl(url, replace, state);
      }
    };
    return $delegate;
  });
});

app.run(function (rmModals) {
  rmModals.init();
});

app.service('rmModals', function ($window, $document, $timeout, $location, $rootScope, $interval) {

  $location.hash('');

  var body = $document.find('body');
  var overlay = angular.element('<div class="modal-overlay"></div>');
  var pointer = angular.element('<div class="modal-pointer"></div>');
  var viewport = angular.element('<div class="modal-viewport"></div>');

  overlay.on('click', function () {
    $timeout(function () {
      $location.hash('$');
    });
  });

  var modals = {};
  var current;

  var open = function () {
    body.append(overlay);
    if (current.anchor) {
      current.anchor.addClass('active');
      viewport.removeClass('rm-modal-popup').addClass('rm-modal-popover');
      pointer.removeClass('top');
      var rect = current.anchor[0].getBoundingClientRect();
      var bottom = body[0].offsetHeight - $window.pageYOffset - rect.top;
      var center = $window.pageXOffset + rect.left + rect.width / 2;
      var maxWidth = 500;
      var bodyWidth = body[0].offsetWidth;
      var left = 0;
      if ($window.pageXOffset + bodyWidth > maxWidth) {
        left = center - maxWidth / 2;
        left = Math.max($window.pageXOffset, Math.min(left, $window.pageXOffset + bodyWidth - maxWidth));
      }
      center = Math.max(left + 35, Math.min(center, left + Math.min(maxWidth, bodyWidth) - 35));
      viewport.css({
        top: '',
        left: left + 'px',
        bottom: bottom + 8 + 'px'
      });
      pointer.css({
        top: '',
        left: center + 'px',
        bottom: bottom + 'px'
      });
      body.append(pointer);
    } else {
      viewport.removeClass('rm-modal-popover').addClass('rm-modal-popup');
    }
    body.append(viewport);

    var reposition = function (modal) {
      if (!current.anchor) {
        // if the modal windows isn't bounded to an anchor point - do nothing
        return angular.noop;
      }
      var lastTop;
      var fixPosition = function () {
        var modalBounds = modal[0].getBoundingClientRect();
        if (false && modalBounds.top === lastTop) {
          //nothing was changed, skip
          return;
        }
        var anchorBounds = current.anchor[0].getBoundingClientRect();
        var body = document.body;
        var docEl = document.documentElement;
        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var top  = anchorBounds.bottom +  scrollTop - clientTop;
        var maxWidth = 500;
        var bodyWidth = body.offsetWidth;
        var left = 0;
        if ($window.pageXOffset + bodyWidth > maxWidth) {
          left = center - maxWidth / 2;
          left = Math.max($window.pageXOffset, Math.min(left, $window.pageXOffset + bodyWidth - maxWidth));
        }
        center = Math.max(left + 35, Math.min(center, left + Math.min(maxWidth, bodyWidth) - 35));
        if (modalBounds.top < 0) {
          viewport.css({
            left: left,
            bottom: '',
            top: top + modalBounds.height + 16 + 'px'
          });
          pointer.css({
            left: center,
            bottom: '',
            top: top + 8 + 'px'
          });
          pointer.addClass('top');
        }
        lastTop = modalBounds.top;
      };
      var refreshInterval = $interval(fixPosition, 100);
      return function () {
        $interval.cancel(refreshInterval);
        pointer.removeClass('top');
      };
    };
    var innerScope = current.scope.$new();
    current.transclude(innerScope, function (clone) {
      clone.addClass('modal-window');
      var cancelReposition = angular.noop;
      if (!$rootScope.alc) {
        clone.css({visibility: 'hidden'});
        pointer.css({visibility: 'hidden'});
        cancelReposition = reposition(clone);
        $timeout(function () {
          clone.css({visibility: ''});
          pointer.css({visibility: ''});
        }, 300, false);
      }
      viewport.append(clone);

      clone.on('$destroy', function () {
        innerScope.$destroy();
        cancelReposition();
      });
    });

  };

  var close = function () {
    viewport.detach().empty();
    pointer.detach();
    overlay.detach();
    if (current.anchor) {
      current.anchor.removeClass('active');
    }
  };

  this.addModal = function (name, transclude, scope) {
    modals[name] = modals[name] || {};
    modals[name].transclude = transclude;
    modals[name].scope = scope;
    scope.$on('$destroy', function () {
      modals[name] = null;
    });
  };

  this.addModalLink = function (name, element) {
    modals[name] = modals[name] || {};
    modals[name].anchor = element;
  };

  this.init = function () {
    $rootScope.$on('$locationChangeSuccess', function () {
      if (current) { close(); }
      current = modals[$location.hash()];
      if (current) { open(); }
    });
  };

});

app.directive('rmModal', function (rmModals) {
  return {
    transclude: 'element',
    priority: 600,
    link: function (scope, element, attrs, ctrl, transclude) {
      var name = scope.$eval(attrs.rmModal);
      rmModals.addModal(name, transclude, scope);
    }
  };
});

app.directive('rmModalLink', function ($timeout, $location, rmModals) {
  return {
    link: function (scope, element, attrs) {
      var name = scope.$eval(attrs.rmModalLink);
      rmModals.addModalLink(name, element);
      element.on('click', function () {
        $timeout(function () {
          $location.hash(name);
        });
      });
    }
  };
});

'use strict';

app.directive('rmPreloader', function ($timeout, $preloader) {
  return {
    restrict: 'C',
    link: function (scope, element) {
      scope.$watch($preloader.state, function () {
        $timeout(function () {
          element.toggleClass('ng-hide', !$preloader.state());
        }, 150, false);
      });
    }
  };
});

'use strict';

app.directive('rmScrollTo', function ($window, $document, $timeout, $viewport) {
  return {
    link: function (scope, element, attrs) {
      if (!angular.element($document[0].body).hasClass('app')) { return; }
      var targetId = attrs.rmScrollTo;
      element.on('click', function () {
        $timeout(function () {
          var target = $document[0].getElementById(targetId);
          if (!target) { return; }
          var padding = $viewport.isDesktop ? 90 : 10;
          var targetTop = target.getBoundingClientRect().top;
          if (targetTop < padding) {
            $window.scrollTo(0, targetTop + $window.pageYOffset - padding);
          }
        }, 100);
      });
    }
  };
});

'use strict';

app.directive('rmVideo', function ($sce, $timeout) {
  return {
    scope: {
      video: '=rmVideo',
      autoplay: '='
    },
    templateUrl: '/app/directives/rm-video/rm-video.html',
    link: function (scope) {

      var youtubeRegExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
      var vimeoRegExp = /\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;

      scope.$watch('video', function (video) {
        scope.playing = false;
        if (video && video.src) {
          var match = video.src.match(youtubeRegExp);
          if (match && match[1]) {
            scope.embed = $sce.trustAsResourceUrl('//www.youtube.com/embed/' + match[1] + '?autoplay=1');
            return;
          }
          match = video.src.match(vimeoRegExp);
          if (match && match[2]) {
            scope.embed = $sce.trustAsResourceUrl('//player.vimeo.com/video/' + match[2] + '?autoplay=1');
            return;
          }
        }
        scope.embed = 'about:blank';
      });

      scope.play = function () {
        scope.playing = true;
      };

      if (scope.autoplay) {
        $timeout(function () {
          scope.playing = true;
        }, 100);
      }

    }
  };
});


angular.module('ui.bootstrap', [
  'ui.bootstrap.dropdown',
  'ui.bootstrap.carousel',
  'ui.bootstrap.datepicker',
  'ui.bootstrap.modal'
]);

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.assessmentQuiz', {
    url: '/assessment',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow('instance.app.assessmentQuiz');
      },
      quiz: function (flow, $http, instance) {
        return $http.get('/api/v1/instances/' + instance._id + '/quizzes/assessment').then(_.property('data'));
      }
    },
    views: {
      '': {
        templateUrl: '/app/states/assessmentQuiz/assessmentQuiz.html',
        controller: function ($window, $scope, $state, instance, quiz) {
          if (!quiz) {
            return;
          }
          $scope.instance = instance;
          $scope.quiz = quiz;

          $scope.answered = [];

          $scope.current = 0;
          $scope.question = quiz.questions[$scope.current];

          $scope.prev = function () {
            if ($scope.current === 0) {
              $state.go('^');
            } else {
              $scope.current--;
              $scope.question = quiz.questions[$scope.current];
            }
          };

          $scope.next = function () {
            if ($scope.answered[$scope.current]) {
              if ($scope.current === quiz.questions.length - 1) {
                quiz.answered = $scope.answered;
                $state.go('.results');
              } else {
                $scope.current++;
                $scope.question = quiz.questions[$scope.current];
              }
            }
          };

          $scope.reply = function (answer) {
            $scope.answered[$scope.current] = answer;
            $scope.next();
          };

          $scope.introCompleted = false;
          $scope.start = function () {
            $scope.introCompleted = true;
            $window.scrollTo(0, 0);
          };

        }
      }
    }
  });

  $stateProvider.state('instance.app.assessmentQuiz.results', {
    views: {
      '@instance': {
        templateUrl: '/app/states/assessmentQuiz/assessmentQuizResults.html',
        controller: function ($scope, $state, $stateParams, instance, quiz, Api) {
          $scope.instance = instance;
          $scope.quiz = quiz;
          $scope.quizType = $stateParams.quizType;
          $scope.score = _.sum(_.map(quiz.answered, 'value'));
          $scope.result = _.find(quiz.response.responses, function (response) {
            return $scope.score >= response.values.min &&  $scope.score <= response.values.max;
          });
          $scope.user.persona = $scope.result ? $scope.result.name : '';
          $scope.user.flowPassed = true;
          $scope.userAnswers = quiz.answered;
          Api.track('instance.assessment', 'pass', {}, { quiz: quiz });
          $scope.continue = function () {
            $state.go('instance.app.dashboard');
          };
        }
      }
    }
  });
});

'use strict';

app.config(function ($popupProvider) {

  $popupProvider.define('terms', function () {
    return /*@ngInject*/ {
      windowClass: 'terms-modal',
      templateUrl: '/app/states/auth/terms.html'
    };
  });

  $popupProvider.define('auth', function (params) {
    return /*@ngInject*/ {
      windowClass: 'auth-modal',
      templateUrl: '/app/states/auth/auth.html',
      controller: function ($scope, $location, $social, $log, $rootScope, $http, Api, rmAnalytics) {

        $scope.credentials = {};

        $scope.view = params.view || 'login';
        if ($scope.view === 'signup-social') {
          rmAnalytics.track('signup');
        }
        $scope.go = function (view) {
          $scope.success = null;
          $scope.error = null;
          $scope.view = view;
        };

        $scope.facebook = function () {
          $social.authenticate('facebook')
            .then($scope.$dismiss)
            .then(Api.refresh)
            .catch(function () {
              $log.warn('failed to signup via facebook', arguments);
            });
        };

        $scope.google = function () {
          $social.authenticate('google')
            .then($scope.$dismiss)
            .then(Api.refresh)
            .catch(function () {
              $log.warn('failed to signup via google', arguments);
            });
        };

        $scope.linkedin = function () {
          $social.authenticate('linkedin')
            .then($scope.$dismiss)
            .then(Api.refresh)
            .catch(function () {
              $log.warn('failed to signup via linkedin', arguments);
            });
        };

        $scope.signupUser = function (credentials) {
          var self = this;
          $http.post('/api/v1/users?instanceId=' + $rootScope.instance._id, credentials)
            .then(function () {
              return Api.login(credentials);
            })
            .then($scope.$dismiss)
            .catch(function () {
              self.signupForm.email.$setValidity('emailAlreadyUsed', false);
              var $unwatch = self.$watch('credentials.email', function (n, o) {
                if (n != o) {
                  self.signupForm.email.$setValidity('emailAlreadyUsed', true);
                  $unwatch();
                }
              });
            });
        };

        $scope.login = function () {
          $scope.error = '';
          Api.login($scope.credentials)
            .then($scope.$dismiss)
            .catch(function () {
              $scope.error = 'The Email Address or Password is incorrect. <br/> Please try again.';
            });
        };

        $scope.forgotPassword = function () {
          $scope.success = null;
          var data = {
            email: $scope.credentials.email
          };
          return $http.post('/api/v1/auth/forgot?instanceId=' + $rootScope.instance._id, data)
            .then(function () {
              $scope.success = true;
            })
            .catch(function () {
              $scope.success = false;
            });
        };

        $scope.resetPassword = function () {
          var data = {
            token: params.token,
            password: $scope.credentials.password
          };
          return $http.post('/api/v1/auth/reset', data)
            .then(function () {
              $scope.$dismiss();
              $scope.success = true;
              Api.refresh();
            })
            .catch(function () {
              $scope.success = false;
            });
        };

      }
    };
  });

});

'use strict';
/*

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.coach', {
    url: '/coach',
    resolve: {
      flow: function (Api, auth) {
        return Api.flow();
      }
    },
    templateUrl: '/app/states/coach/coach.html',
    controller: function ($scope) {
      $scope.coaches = [
        {
          name: 'Benjamin Rifkin',
          title: 'Provost and Vice President for Educational Affairs',
          photo: '/stubs/coaches/BenjaminRifkin.jpg'
        }, {
          name: 'Dawn Kline',
          title: 'Assistant Dean, School of Business',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_200_200/p/8/000/2b5/2e7/1d18bdf.jpg'
        }, {
          name: 'Paula Perna',
          title: 'Director, External Relations',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_400_400/p/1/005/05d/185/104dea1.jpg'
        }, {
          name: 'John Fraccia',
          title: 'Associate Director of Career Services',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_200_200/p/1/000/0cf/182/0d75493.jpg'
        }, {
          name: 'Ayana Richardson',
          title: 'Assistant Dean',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_200_200/p/2/000/1ae/388/1ad79c6.jpg'
        }, {
          name: 'Brad Treat',
          title: 'Practical Entrepreneurship Instructor',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_200_200/p/4/005/0ac/08b/3352fa2.jpg'
        }, {
          name: 'Steve Savage',
          title: 'Associate Vice President for Institutional Advancement at IthacaCollege',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_100_100/p/1/000/19d/068/0a29c0a.jpg'
        }, {
          name: 'Catrina Decker',
          title: 'Academic Services Coordinator',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_200_200/p/1/000/094/3f6/151219c.jpg'
        }, {
          name: 'Steve Gonick',
          title: 'Executive in Residence',
          photo: 'https://media.licdn.com/mpr/mpr/shrink_100_100/p/1/000/035/0e5/159050f.jpg'
        }
      ];
    }
  });

});
*/

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.dashboard', {
    url: '/',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      history: function (flow, Api, instance) {
        return Api.history(instance);
      }
    },
    templateUrl: '/app/states/dashboard/dashboard.html',
    controller: function ($scope, $state, $http, history, Api, HistoryAction, rmGuide) {
      var guideId = 'homeScreen';
      var guide =  _.find($scope.instance.guides, { id: guideId });
      var wasShownToUser = _.find($scope.user.meta.instance.guides, { id: guideId});
      $scope.introductionGuide = !wasShownToUser && (guide && guide.enabled) ? _.cloneDeep(guide) : false;
      $scope.showTutorial = !$scope.introductionGuide && _.get($scope.instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.instance.tutorial.id);
      };
      $scope.onGuideExit = function () {
        return $http.post('/api/v1/me/guides/' + guideId).then(Api.me);
      };
      $scope.onGuideCompleted = function () {
        $scope.showTutorial = _.get($scope.instance, 'tutorial.enabled', false);
        $scope.onGuideExit().then(function () {
          $state.go('instance.app.module', {
            moduleId: _.first($scope.instance.modules)._id
          });
        });
      };
      Api.track('dashboard', 'view', {});
      $scope.history = history;
      $scope.history.recent.forEach(HistoryAction.format);

      $scope.graph = {
        labels: _.pluck(history.ranges, 'label'),
        series: [_.pluck(history.ranges, 'points')]
      };

      $scope.next = function (step) {
        if (step.name == 'module.introduction') {
          step.name = 'module';
        }
        $state.go('instance.app.' + step.name, step.params);
      };

      $scope.openDoc = function (doc) {
        $scope.$popup('pdf', { type: 'user', src: doc });
      };

    }
  });

});

'use strict';

app.config(function ($popupProvider) {
  $popupProvider.define('doc-save', function (params) {
    return /*@ngInject*/ {
      windowClass: 'prompt-modal',
      template: [
        '<div class="prompt">',
          '<div class="prompt-body">Your <span ng-bind-html="documentNames.join(\', <br/>\')"></span> has been saved to your docs.</div>',
          '<div class="prompt-footer">',
            '<button class="btn btn-go" ng-click="$close()">Ok</button> ',
          '</div>',
        '</div>'
      ].join(''),
      controller: function ($scope) {
        $scope.documentNames = params.documentNames;
      }
    };
  });

});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.docs', {
    url: '/docs',
    templateUrl: '/app/states/docs/docs.html',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      docs: function (flow, $http) {
        return $http.get('/api/v1/me/documents').then(_.property('data'));
      }
    },
    controller: function ($scope, $window, $state, $interval, $http, docs) {
      function update () {
        if (!_.find($scope.docs, {status: 'pending'})) {
          return;
        }
        $http.get('/api/v1/me/documents').then(_.property('data')).then( function (docs) {
          _.filter($scope.docs, {status: 'pending'}).forEach( function (doc) {
            var newDoc = _.find(docs, {_id: doc._id});
            if (newDoc) {
              _.assign(doc, newDoc);
            }
          });
        });
      }
      var interval = $interval(update, 5000, 0, false);
      $scope.$on('$destroy', function () {
        $interval.cancel(interval);
      });
      $scope.docs = docs;
      $scope.config = { itemsPerPage: 10, maxPages: 3 };
      _.forEach(docs, function (doc) {
        doc.createdAt = new Date(doc.createdAt);
        doc.sourceName = doc.sourceParams.byteName || '';
      });
      $scope.openDoc = function (doc) {
        if (doc.status == 'pending') { return; }
        $scope.$popup('pdf', { type: 'user', src: doc });
      };
      $scope.download = function ($event, doc) {
        $event.stopPropagation();
        $window.open('/api/v1/me/documents/' + doc._id + '/pdf?download=true');
      };
      $scope.source = function ($event, doc) {
        $event.stopPropagation();
        $state.go('^.module.lesson.byte', doc.sourceParams);
      };
    }
  });

});

'use strict';

app.config(function ($stateProvider) {
  var PER_PAGE = 14;

  $stateProvider.state('instance.app.leaderboard', {
    url: '/leaderboard',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      leaderboard: function (flow, Leaderboard, $rootScope) {
        return Leaderboard.fetch($rootScope.instance._id, { limit: PER_PAGE });
      },
      chart: function (flow, $http) {
        return $http.get('/api/v1/me/chart/weeklyProgress')
          .then(_.property('data'));
      },
      userRank: function (flow, Leaderboard, $rootScope) {
        return Leaderboard.userRank($rootScope.instance._id, $rootScope.user._id).catch(_.constant(null));
      },
      achievements: function (flow, $http) {
        return $http.get('/api/v1/me/achievements')
          .then(_.property('data'));
      }
    },
    templateUrl: '/app/states/leaderboard/leaderboard.html',
    controller: function ($scope, leaderboard, userRank, achievements, chart, Leaderboard, HistoryAction, $viewport) {
      $scope.graph = {
        labels: _.map(chart, function (data) { return data.label.toUpperCase(); }),
        series: [_.pluck(chart, 'points')]
      };
      var chartPadding = $viewport.isMobile ? 20 : 50;
      $scope.graphOptions = {
        axisY: { showLabel: false, showGrid: false, offset: 0 },
        chartPadding: { top: chartPadding, right: chartPadding, bottom: 20, left: chartPadding },
        fullWidth: true,
        axisX: { offset: 30, labelOffset: { x: $viewport.isMobile ? -8 : -16, y: 20}, showGrid: false }
      };
      $scope.increaseThisWeek = _.sum(chart, 'points');
      $scope.tooltips = _.map(chart, function (data) {
        data.history.forEach(HistoryAction.format);
        return {
          label: data.weekday,
          history: data.history
        };
      });
      achievements.modulesCompleted = _.chunk(achievements.modulesCompleted, 2);
      $scope.achievements = achievements;
      $scope.expanded = false;
      var injectCurrentUser = function (leaderboard) {
        if (!userRank) {
          return leaderboard;
        }
        if (!_.find(leaderboard, {user: $scope.user._id})) {
          //push current user to the end of the leaderboard overview
          leaderboard[leaderboard.length - 1] = userRank;
        }
        return leaderboard;
      };
      var chunkLeaderboard = function (leaderboard) {
        if (!leaderboard.length) {
          return [];
        }
        var leaderBoardOverview = _.cloneDeep(leaderboard);
        injectCurrentUser(leaderBoardOverview);
        //mark last user, required for css styles
        _.last(leaderboard).isLast = true;
        return _.chunk(leaderBoardOverview, Math.ceil(leaderboard.length / 2));
      };
      $scope.leaderboardChunked = chunkLeaderboard(leaderboard || []);

      var loadNextPage = function () {
        Leaderboard.fetch($scope.instance._id, {
          skip: leaderboard.length,
          limit: PER_PAGE
        }).then(function (data) {
          $scope.lastPage = data.length < PER_PAGE;
          leaderboard = leaderboard.concat(data);
          $scope.leaderboardChunked = chunkLeaderboard(leaderboard);
        });
      };
      $scope.expand = function () {
        loadNextPage();
        $scope.expanded = true;
      };
      $scope.loadNextPage = loadNextPage;
    }
  });

});

'use strict';
/*
app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.mentor', {
    url: '/mentor',
    resolve: {
      flow: function (Api, auth) {
        return Api.flow();
      }
    },
    templateUrl: '/app/states/mentor/mentor.html',
    controller: function ($scope) {
      $scope.mentors = [
        {
          name: 'Eli Petrucci ',
          title: 'Provost and Vice President for Educational Affairs',
          photo: '/stubs/mentors/m1.jpg',
          experience: '10 Years',
          availability: 'Quarterly',
          mode: 'Phone',
          industry: 'Accounting'
        }, {
          name: 'Lillian Dixon',
          title: 'Assistant Dean, School of Business',
          photo: '/stubs/mentors/m2.jpg',
          experience: '25 Years',
          availability: 'Quarterly',
          mode: 'In Person',
          industry: 'Media and Entertainment'
        }, {
          name: 'Suanne Keeler',
          title: 'Director, External Relations',
          photo: '/stubs/mentors/m3.jpg',
          experience: '35 Years',
          availability: 'Bi-Monthly',
          mode: 'Phone',
          industry: 'Engineering'
        }, {
          name: 'Leo Shellhammer',
          title: 'Associate Director of Career Services',
          photo: '/stubs/mentors/m4.jpg',
          experience: '7 Years',
          availability: 'Bi-Monthly',
          mode: 'In Person',
          industry: 'Education'
        }, {
          name: 'Noelle Hollins',
          title: 'Assistant Dean',
          photo: '/stubs/mentors/m5.jpg',
          experience: '18 Years',
          availability: 'Weekly',
          mode: 'Phone',
          industry: 'Health Care Management'
        }
      ];
    }
  });

});
*/

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module', {
    url: '/module/:moduleId?expandedLessonId',
    reloadOnSearch: false,
    templateUrl: '/app/states/module/module.html',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      module: function (flow, Api, $stateParams) {
        return Api.module($stateParams.moduleId);
      }
    },
    controller: function ($scope, $stateParams, module, instance, Api, rmMacroService, $state, $http, $window, $viewport, rmGuide) {
      var guideId = 'lessonScreen';
      var guide =  _.find($scope.instance.guides, { id: guideId });
      var wasShownToUser = _.find($scope.user.meta.instance.guides, { id: guideId});
      $scope.introductionGuide = !wasShownToUser && (guide && guide.enabled) ? _.cloneDeep(guide) : false;
      $scope.showTutorial = !$scope.introductionGuide && _.get(instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.module.tutorial.id);
      };
      $scope.onGuideExit = function () {
        return $http.post('/api/v1/me/guides/' + guideId).then(Api.me);
      };
      $scope.onGuideCompleted = function () {
        $window.scrollTo(0, 0);
        $scope.onGuideExit();
        $scope.showTutorial = _.get(instance, 'tutorial.enabled', false);
      };

      $scope.module = module;
      rmMacroService.set('module', module);

      Api.track('module.introduction', 'pass');

      $scope.expandedLessonId = $stateParams.expandedLessonId;

      $scope.$watch('$viewport.isMobile', function (isMobile) {
        var cols = isMobile ? 1 : 3;
        $scope.chunks = _([].concat(module.quizzes.pre, module.lessons, module.quizzes.post))
          .compact()
          .filter()
          .groupBy(function (element, index) { return index % cols; }).toArray().value();
      });

      $scope.carousel = function (lesson) {
        if (!$viewport.isMobile) { return; }
        $state.go('.carousel', { lessonId: lesson._id });
      };
    }
  });

});

'use strict';

app.config(function ($popupProvider) {

  $popupProvider.define('pdf-remove', function () {
    return /*@ngInject*/ {
      windowClass: 'pdf-remove-modal',
      templateUrl: '/app/states/pdf/pdf-remove.html'
    };
  });

  $popupProvider.define('pdf', function (params) {
    return /*@ngInject*/ {
      windowClass: 'pdf-modal',
      templateUrl: '/app/states/pdf/pdf.html',
      controller: function ($scope, $window, $document, $timeout, $http, $state, Documents) {

        var body = $document.find('body');

        var iframe = function (src) {
          var frame = angular.element('<iframe style="display:none;"></iframe>');
          frame.attr('src', src);
          body.append(frame);
          return frame;
        };

        var download = function (src) {
          iframe(src);
        };

        var print = function (src) {
          iframe(src).on('load', function () {
            try {
              this.contentWindow.print();
            } catch (e) {
              $window.alert(e);
            }
          });
        };

        if (params.type == 'inline') {
          $http.get('/api/v1/files/' + params.src._id).then(function (resp) {
            var file = resp.data;
            $scope.pdf = {
              isUserDoc: !!file.userDoc,
              userDoc: file.userDoc,
              images: file.images,
              link: '/api/v1/files/' + params.src._id + '/pdf?download=true',
              download: function () {
                download('/api/v1/files/' + params.src._id + '/pdf?download=true');
              },
              print: function () {
                print('/api/v1/files/' + params.src._id + '/pdf');
              },
              save: function () {
                var name = '';
                if ($scope.module) { name += $scope.module.name + ' Module → '; }
                if ($scope.lesson) { name += $scope.lesson.name + ' → '; }
                if ($scope.byte) { name += $scope.byte.name + ' → '; }
                name += file.meta.originalName;
                var doc = {
                  name: name,
                  sourceType: 'inline',
                  sourceParams: {
                    instanceId: file.meta.instanceId,
                    fileId: file._id
                  }
                };
                Documents.save(doc).then(function () {
                  $scope.pdf.isUserDoc = true;
                  $scope.pdf.userDoc = resp.data;
                });
              },
              remove: function () {
                $scope.$popup('pdf-remove').then(function () {
                  Documents.remove($scope.pdf.userDoc._id).then(function () {
                    $scope.pdf.isUserDoc = false;
                    $scope.pdf.userDoc = null;
                  });
                });
              }
            };
          });
        } else {
          $scope.pdf = {
            isUserDoc: true,
            images: params.src.links.images,
            link: '/api/v1/me/documents/' + params.src._id + '/pdf?download=true',
            download: function () {
              download('/api/v1/me/documents/' + params.src._id + '/pdf?download=true');
            },
            print: function () {
              print('/api/v1/me/documents/' + params.src._id + '/pdf');
            },
            remove: function () {
              $scope.$popup('pdf-remove').then(function () {
                Documents.remove(params.src._id).then(function () {
                  $scope.$dismiss();
                  $state.reload();
                });
              });
            }
          };
        }
      }
    };
  });

});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.profile', {
    url: '/profile',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow('instance.app.profile');
      }
    },
    templateUrl: '/app/states/profile/profile.html',
    controller: function ($scope, $window, $state, $http, $timeout, $popup, $preloader, Api) {
      $scope.date = new Date();
      $scope.months = [
        'January', 'February', 'March', 'April', 'May',
        'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ];
      $scope.user.dates.enrollment = _.isObject($scope.user.dates.enrollment) ? $scope.user.dates.enrollment : { year: 2020 };
      $scope.user.dates.graduation = _.isObject($scope.user.dates.graduation) ? $scope.user.dates.graduation : { year: 2015 };

      $scope.user.internships = $scope.user.internships || [];
      $scope.user.hasInternship = !!$scope.user.internships.length;
      $scope.$watch('user.hasInternship', function (hasInternship, prev) {
        if (hasInternship === prev) { return; }
        if (hasInternship) {
          $scope.user.internships = [{}, {}];
        } else {
          $scope.user.internships.length = 0;
        }
      });

      $scope.avatar = function () {
        if (!$window.FileReader || !$window.Blob) {
          $popup('prompt', {
            message: 'Your Browser doesn\'t support this feature.'
          });
        } else {
          $popup('avatar', { url: $scope.user.avatar }).then(function (avatar) {
            $scope.user.avatar = avatar;
            return $http.put('/api/v1/me', { avatar: avatar });
          });
        }
      };

      $scope.save = function () {
        $preloader.show();
        $http.put('/api/v1/me', $scope.user)
          .finally(function () {
            $preloader.hide();
            $timeout(function () {
              $scope.message = '';
            }, 5000);
          })
          .then(function () {
            return Api.track('user.profile', 'pass');
          })
          .then(function () {
            $scope.profile.$setPristine();
            $scope.user.flowPassed = _.get($scope.user, 'meta.profileCompleted', false) && $scope.user.persona;
            if (!$scope.user.persona) {
              $state.go('instance.app.assessmentQuiz');
            } else {
              $popup('prompt', { message: 'Your Profile was Successfully Updated' });
            }
          })
          .catch(function (response) {
            if (response.status == 400) {
              if (_.get(response, 'data.errors.email', null)) {
                $popup('prompt', { message: 'Your email address has already been used.' });
              }
            }
            $scope.message = 'Something went wrong';
          });
      };
    }
  });

});

'use strict';

app.directive('rmUserDateYear', function () {
  return {
    require: ['^rmUserDate', 'ngModel'],
    link: function (scope, element, attr, ctrls) {
      ctrls[0].addYear(ctrls[1]);
    }
  };
});
app.directive('rmUserDateMonth', function () {
  return {
    require: ['^rmUserDate', 'ngModel'],
    link: function (scope, element, attr, ctrls) {
      ctrls[0].addMonth(ctrls[1]);
    }
  };
});
app.directive('rmUserDate', function () {
  return {
    require: ['^form', 'ngModel'],
    scope: true,
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl  = ctrls[0];
      scope.modelCtrl = ctrls[1];
    },
    controller: function ($scope, $attrs) {
      this.addMonth = function (model) {
        this.month = model;
      };
      this.addYear = function (model) {
        this.year = model;
      };
      var self = this;
      var validate = function () {
        //should accept the year + month, and and year without month
        if (_.isNull(self.month.$modelValue) && _.isNull(self.month.$modelValue)) {
          self.year.$setValidity('rmUserDate', true);
          self.month.$setValidity('rmUserDate', true);
        } else {
          var dateIsDefined = (!_.isNull(self.year.$modelValue) && !_.isNull(self.month.$modelValue) || !_.isNull(self.year.$modelValue));
          self.year.$setValidity('rmUserDate', dateIsDefined);
          self.month.$setValidity('rmUserDate', dateIsDefined);
        }
        if ($attrs.lessThan && $scope.modelCtrl.$modelValue.year && $scope.formCtrl[$attrs.lessThan].$modelValue.year) {
          var lessThan = new Date($scope.formCtrl[$attrs.lessThan].$modelValue.year, $scope.formCtrl[$attrs.lessThan].$modelValue.month);
          var date = new Date($scope.modelCtrl.$modelValue.year, $scope.modelCtrl.$modelValue.month);
          self.year.$setValidity('rmUserDateLessThan',  date < lessThan);
          self.month.$setValidity('rmUserDateLessThan', _.isNull(self.month.$modelValue) ? true : date < lessThan);
        } else {
          self.year.$setValidity('rmUserDateLessThan',  true);
          self.month.$setValidity('rmUserDateLessThan', true);
        }
      };
      $scope.$watch(function () {
        return (self.year ? self.year.$modelValue : '') + '' + (self.month ? self.month.$modelValue : '');
      }, validate, true);
      if ($attrs.lessThan) {
        $scope.$watch(function () {
          return $scope.formCtrl[$attrs.lessThan].$modelValue.year ? $scope.formCtrl[$attrs.lessThan].$modelValue : '';
        }, validate, true);
      }
    }
  };
});

'use strict';

app.directive('rmTopnav', function ($timeout) {
  return {
    scope: true,
    templateUrl: '/app/states/topnav/topnav.html',
    controller: function ($scope) {
      $scope.scored = 0;
      var timer;
      $scope.$watch('user.points', function (next, prev) {
        if (!next || next === prev) { return; }
        $scope.scored = next - prev;
        $timeout.cancel(timer);
        timer = $timeout(function () {
          $scope.scored = 0;
        }, 6000);
      });
    }
  };
});

'use strict';

// make slider expand to height of largest slide
// by adding hidden spacer clone for each slide
app.directive('slide', function () {
  return {
    require: '^carousel',
    restrict: 'EA',
    link: function (scope, element, attrs, carouselCtrl, transclude) {
      transclude(function (clone) {
        var spacer = angular.element('<div class="spacer"></div>');
        spacer.append(clone);
        element.after(spacer);
      });
    }
  };
});

// jscs:disable
// jshint ignore:start

/**
* @ngdoc overview
* @name ui.bootstrap.carousel
*
* @description
* AngularJS version of an image carousel.
*
*/
angular.module('ui.bootstrap.carousel', ['ui.bootstrap.transition'])
.controller('CarouselController', ['$scope', '$timeout', '$interval', '$transition', function ($scope, $timeout, $interval, $transition) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    currentIndex = -1,
    currentInterval, isPlaying;
  self.currentSlide = null;

  var destroyed = false;
  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = slides.indexOf(nextSlide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > currentIndex ? 'next' : 'prev';
    }
    if (nextSlide && nextSlide !== self.currentSlide) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition.cancel();
        //Timeout so ng-class in template has time to fix classes for finished slide
        $timeout(goNext);
      } else {
        goNext();
      }
    }
    function goNext() {
      // Scope has been destroyed, stop here.
      if (destroyed) { return; }
      //If we have a slide to transition from and we have a transition type and we're allowed, go
      if (self.currentSlide && angular.isString(direction) && !$scope.noTransition && nextSlide.$element) {
        //We shouldn't do class manip in here, but it's the same weird thing bootstrap does. need to fix sometime
        nextSlide.$element.addClass(direction);
        var reflow = nextSlide.$element[0].offsetWidth; //force reflow

        //Set all other slides to stop doing their stuff for the new transition
        angular.forEach(slides, function(slide) {
          angular.extend(slide, {direction: '', entering: false, leaving: false, active: false});
        });
        angular.extend(nextSlide, {direction: direction, active: true, entering: true});
        angular.extend(self.currentSlide||{}, {direction: direction, leaving: true});

        $scope.$currentTransition = $transition(nextSlide.$element, {});
        //We have to create new pointers inside a closure since next & current will change
        (function(next,current) {
          $scope.$currentTransition.then(
            function(){ transitionDone(next, current); },
            function(){ transitionDone(next, current); }
          );
        }(nextSlide, self.currentSlide));
      } else {
        transitionDone(nextSlide, self.currentSlide);
      }
      self.currentSlide = nextSlide;
      currentIndex = nextIndex;
      //every time you change slides, reset the timer
      restartTimer();
    }
    function transitionDone(next, current) {
      angular.extend(next, {direction: '', active: true, leaving: false, entering: false});
      angular.extend(current||{}, {direction: '', active: false, leaving: false, entering: false});
      $scope.$currentTransition = null;
    }
  };
  $scope.$on('$destroy', function () {
    destroyed = true;
  });

  /* Allow outside people to call indexOf on slides array */
  self.indexOfSlide = function(slide) {
    return slides.indexOf(slide);
  };

  $scope.next = function() {
    var newIndex = (currentIndex + 1) % slides.length;

    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (!$scope.$currentTransition) {
      return self.select(slides[newIndex], 'next');
    }
  };

  $scope.prev = function() {
    var newIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;

    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (!$scope.$currentTransition) {
      return self.select(slides[newIndex], 'prev');
    }
  };

  $scope.isActive = function(slide) {
     return self.currentSlide === slide;
  };

  $scope.$watch('interval', restartTimer);
  $scope.$on('$destroy', resetTimer);

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };
  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  self.addSlide = function(slide, element) {
    slide.$element = element;
    slides.push(slide);
    //if this is the first slide or the slide is set to active, select it
    if(slides.length === 1 || slide.active) {
      self.select(slides[slides.length-1]);
      if (slides.length == 1) {
        $scope.play();
      }
    } else {
      slide.active = false;
    }
  };

  self.removeSlide = function(slide) {
    //get the index of the slide inside the carousel
    var index = slides.indexOf(slide);
    slides.splice(index, 1);
    if (slides.length > 0 && slide.active) {
      if (index >= slides.length) {
        self.select(slides[index-1]);
      } else {
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
    }
  };

}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:carousel
 * @restrict EA
 *
 * @description
 * Carousel is the outer container for a set of image 'slides' to showcase.
 *
 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <carousel>
      <slide>
        <img src="http://placekitten.com/150/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>Beautiful!</p>
        </div>
      </slide>
      <slide>
        <img src="http://placekitten.com/100/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>D'aww!</p>
        </div>
      </slide>
    </carousel>
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
 */
.directive('carousel', [function() {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    controller: 'CarouselController',
    require: 'carousel',
    templateUrl: '/app/directives/ui-bootstrap/carousel/carousel.html',
    scope: {
      interval: '=',
      noTransition: '=',
      noPause: '='
    }
  };
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:slide
 * @restrict EA
 *
 * @description
 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
 *
 * @param {boolean=} active Model binding, whether or not this slide is currently active.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
<div ng-controller="CarouselDemoCtrl">
  <carousel>
    <slide ng-repeat="slide in slides" active="slide.active">
      <img ng-src="{{slide.image}}" style="margin:auto;">
      <div class="carousel-caption">
        <h4>Slide {{$index}}</h4>
        <p>{{slide.text}}</p>
      </div>
    </slide>
  </carousel>
  Interval, in milliseconds: <input type="number" ng-model="myInterval">
  <br />Enter a negative number to stop the interval.
</div>
  </file>
  <file name="script.js">
function CarouselDemoCtrl($scope) {
  $scope.myInterval = 5000;
}
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
*/

.directive('slide', function() {
  return {
    require: '^carousel',
    restrict: 'EA',
    transclude: true,
    replace: true,
    templateUrl: '/app/directives/ui-bootstrap/carousel/slide.html',
    scope: {
      active: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        if (active) {
          carouselCtrl.select(scope);
        }
      });
    }
  };
});

// jscs:disable
// jshint ignore:start

angular.module('ui.bootstrap.dateparser', [])

.service('dateParser', ['$locale', 'orderByFilter', function($locale, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  this.parsers = {};

  var formatCodeToRegex = {
    'yyyy': {
      regex: '\\d{4}',
      apply: function(value) { this.year = +value; }
    },
    'yy': {
      regex: '\\d{2}',
      apply: function(value) { this.year = +value + 2000; }
    },
    'y': {
      regex: '\\d{1,4}',
      apply: function(value) { this.year = +value; }
    },
    'MMMM': {
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
    },
    'MMM': {
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
    },
    'MM': {
      regex: '0[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'M': {
      regex: '[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'dd': {
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'd': {
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'EEEE': {
      regex: $locale.DATETIME_FORMATS.DAY.join('|')
    },
    'EEE': {
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
    },
    'HH': {
      regex: '(?:0|1)[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'H': {
      regex: '1?[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'mm': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'm': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'sss': {
      regex: '[0-9][0-9][0-9]',
      apply: function(value) { this.milliseconds = +value; }
    },
    'ss': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    's': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    }
  };

  function createParser(format) {
    var map = [], regex = format.split('');

    angular.forEach(formatCodeToRegex, function(data, code) {
      var index = format.indexOf(code);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + code.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({ index: index, apply: data.apply });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  this.parse = function(input, format, baseDate) {
    if ( !angular.isString(input) || !format ) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ( !this.parsers[format] ) {
      this.parsers[format] = createParser(format);
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex);

    if ( results && results.length ) {
      var fields, dt;
      if (baseDate) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for( var i = 1, n = results.length; i < n; i++ ) {
        var mapper = map[i-1];
        if ( mapper.apply ) {
          mapper.apply.call(fields, results[i]);
        }
      }

      if ( isValid(fields.year, fields.month, fields.date) ) {
        dt = new Date(fields.year, fields.month, fields.date, fields.hours, fields.minutes, fields.seconds,
          fields.milliseconds || 0);
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if ( month === 1 && date > 28) {
        return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    }

    if ( month === 3 || month === 5 || month === 8 || month === 10) {
        return date < 31;
    }

    return true;
  }
}]);

'use strict';

// default datepicker options
app.config(function (datepickerConfig, datepickerPopupConfig) {
  datepickerConfig.showWeeks = false;
  datepickerPopupConfig.appendToBody = true;
  datepickerPopupConfig.showButtonBar = false;
  datepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
});


// jscs:disable
// jshint ignore:start

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])

.constant('datepickerConfig', {
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  datepickerMode: 'day',
  minMode: 'day',
  maxMode: 'year',
  showWeeks: true,
  startingDay: 0,
  yearRange: 20,
  minDate: null,
  maxDate: null,
  shortcutPropagation: false
})

.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$timeout', '$log', 'dateFilter', 'datepickerConfig', function($scope, $attrs, $parse, $interpolate, $timeout, $log, dateFilter, datepickerConfig) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  // Configuration attributes
  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
                   'minMode', 'maxMode', 'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function( key, index ) {
    self[key] = angular.isDefined($attrs[key]) ? (index < 8 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
  });

  // Watchable date attributes
  angular.forEach(['minDate', 'maxDate'], function( key ) {
    if ( $attrs[key] ) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = value ? new Date(value) : null;
        self.refreshView();
      });
    } else {
      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
    }
  });

  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
  $scope.maxMode = self.maxMode;
  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  if(angular.isDefined($attrs.initDate)) {
    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
    $scope.$parent.$watch($attrs.initDate, function(initDate){
      if(initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)){
        self.activeDate = initDate;
        self.refreshView();
      }
    });
  } else {
    this.activeDate =  new Date();
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function( ngModelCtrl_ ) {
    ngModelCtrl = ngModelCtrl_;

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if ( ngModelCtrl.$viewValue ) {
      var date = new Date( ngModelCtrl.$viewValue ),
          isValid = !isNaN(date);

      if ( isValid ) {
        this.activeDate = date;
      } else {
        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
      }
      ngModelCtrl.$setValidity('date', isValid);
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if ( this.element ) {
      this._refreshView();

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      ngModelCtrl.$setValidity('date-disabled', !date || (this.element && !this.isDisabled(date)));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    return {
      date: date,
      label: dateFilter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      current: this.compare(date, new Date()) === 0,
      customClass: this.customClass(date)
    };
  };

  this.isDisabled = function( date ) {
    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
  };

    this.customClass = function( date ) {
      return $scope.customClass({date: date, mode: $scope.datepickerMode});
    };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function( date ) {
    if ( $scope.datepickerMode === self.minMode ) {
      var dt = ngModelCtrl.$viewValue ? new Date( ngModelCtrl.$viewValue ) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear( date.getFullYear(), date.getMonth(), date.getDate() );
      ngModelCtrl.$setViewValue( dt );
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) - 1 ];
    }
  };

  $scope.move = function( direction ) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function( direction ) {
    direction = direction || 1;

    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
      return;
    }

    $scope.datepickerMode = self.modes[ self.modes.indexOf( $scope.datepickerMode ) + direction ];
  };

  // Key event mapper
  $scope.keys = { 13:'enter', 32:'space', 33:'pageup', 34:'pagedown', 35:'end', 36:'home', 37:'left', 38:'up', 39:'right', 40:'down' };

  var focusElement = function() {
    $timeout(function() {
      self.element[0].focus();
    }, 0 , false);
  };

  // Listen for focus requests from popup directive
  $scope.$on('datepicker.focus', focusElement);

  $scope.keydown = function( evt ) {
    var key = $scope.keys[evt.which];

    if ( !key || evt.shiftKey || evt.altKey ) {
      return;
    }

    evt.preventDefault();
    if(!self.shortcutPropagation){
        evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if ( self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
      focusElement();
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
      focusElement();
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };
}])

.directive( 'datepicker', function () {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: '/app/directives/ui-bootstrap/datepicker/datepicker.html',
    scope: {
      datepickerMode: '=?',
      dateDisabled: '&',
      customClass: '&',
      shortcutPropagation: '&?'
    },
    require: ['datepicker', '?^ngModel'],
    controller: 'DatepickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if ( ngModelCtrl ) {
        datepickerCtrl.init( ngModelCtrl );
      }
    }
  };
})

.directive('daypicker', ['dateFilter', function (dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: '/app/directives/ui-bootstrap/datepicker/day.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      scope.showWeeks = ctrl.showWeeks;

      ctrl.step = { months: 1 };
      ctrl.element = element;

      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function getDaysInMonth( year, month ) {
        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
      }

      function getDates(startDate, n) {
        var dates = new Array(n), current = new Date(startDate), i = 0;
        current.setHours(12); // Prevent repeated dates because of timezone bug
        while ( i < n ) {
          dates[i++] = new Date(current);
          current.setDate( current.getDate() + 1 );
        }
        return dates;
      }

      ctrl._refreshView = function() {
        var year = ctrl.activeDate.getFullYear(),
          month = ctrl.activeDate.getMonth(),
          firstDayOfMonth = new Date(year, month, 1),
          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
          firstDate = new Date(firstDayOfMonth);

        if ( numDisplayedFromPreviousMonth > 0 ) {
          firstDate.setDate( - numDisplayedFromPreviousMonth + 1 );
        }

        // 42 is the number of days on a six-month calendar
        var days = getDates(firstDate, 42);
        for (var i = 0; i < 42; i ++) {
          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
            secondary: days[i].getMonth() !== month,
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.labels = new Array(7);
        for (var j = 0; j < 7; j++) {
          scope.labels[j] = {
            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
            full: dateFilter(days[j].date, 'EEEE')
          };
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
        scope.rows = ctrl.split(days, 7);

        if ( scope.showWeeks ) {
          scope.weekNumbers = [];
          var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
              numWeeks = scope.rows.length;
          for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
            scope.weekNumbers.push(
              getISO8601WeekNumber( scope.rows[curWeek][thursdayIndex].date ));
          }
        }
      };

      ctrl.compare = function(date1, date2) {
        return (new Date( date1.getFullYear(), date1.getMonth(), date1.getDate() ) - new Date( date2.getFullYear(), date2.getMonth(), date2.getDate() ) );
      };

      function getISO8601WeekNumber(date) {
        var checkDate = new Date(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
        var time = checkDate.getTime();
        checkDate.setMonth(0); // Compare with Jan 1
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
      }

      ctrl.handleKeyDown = function( key, evt ) {
        var date = ctrl.activeDate.getDate();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 7;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 7;
        } else if (key === 'pageup' || key === 'pagedown') {
          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setMonth(month, 1);
          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
        } else if (key === 'home') {
          date = 1;
        } else if (key === 'end') {
          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
        }
        ctrl.activeDate.setDate(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('monthpicker', ['dateFilter', function (dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: '/app/directives/ui-bootstrap/datepicker/month.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      ctrl.step = { years: 1 };
      ctrl.element = element;

      ctrl._refreshView = function() {
        var months = new Array(12),
            year = ctrl.activeDate.getFullYear();

        for ( var i = 0; i < 12; i++ ) {
          months[i] = angular.extend(ctrl.createDateObject(new Date(year, i, 1), ctrl.formatMonth), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
        scope.rows = ctrl.split(months, 3);
      };

      ctrl.compare = function(date1, date2) {
        return new Date( date1.getFullYear(), date1.getMonth() ) - new Date( date2.getFullYear(), date2.getMonth() );
      };

      ctrl.handleKeyDown = function( key, evt ) {
        var date = ctrl.activeDate.getMonth();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 3;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 3;
        } else if (key === 'pageup' || key === 'pagedown') {
          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setFullYear(year);
        } else if (key === 'home') {
          date = 0;
        } else if (key === 'end') {
          date = 11;
        }
        ctrl.activeDate.setMonth(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('yearpicker', ['dateFilter', function (dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: '/app/directives/ui-bootstrap/datepicker/year.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      var range = ctrl.yearRange;

      ctrl.step = { years: range };
      ctrl.element = element;

      function getStartingYear( year ) {
        return parseInt((year - 1) / range, 10) * range + 1;
      }

      ctrl._refreshView = function() {
        var years = new Array(range);

        for ( var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++ ) {
          years[i] = angular.extend(ctrl.createDateObject(new Date(start + i, 0, 1), ctrl.formatYear), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = [years[0].label, years[range - 1].label].join(' - ');
        scope.rows = ctrl.split(years, 5);
      };

      ctrl.compare = function(date1, date2) {
        return date1.getFullYear() - date2.getFullYear();
      };

      ctrl.handleKeyDown = function( key, evt ) {
        var date = ctrl.activeDate.getFullYear();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 5;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 5;
        } else if (key === 'pageup' || key === 'pagedown') {
          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
        } else if (key === 'home') {
          date = getStartingYear( ctrl.activeDate.getFullYear() );
        } else if (key === 'end') {
          date = getStartingYear( ctrl.activeDate.getFullYear() ) + range - 1;
        }
        ctrl.activeDate.setFullYear(date);
      };

      ctrl.refreshView();
    }
  };
}])

.constant('datepickerPopupConfig', {
  datepickerPopup: 'yyyy-MM-dd',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  currentText: 'Today',
  clearText: 'Clear',
  closeText: 'Done',
  closeOnDateSelection: true,
  appendToBody: false,
  showButtonBar: true
})

.directive('datepickerPopup', ['$compile', '$parse', '$document', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig',
function ($compile, $parse, $document, $position, dateFilter, dateParser, datepickerPopupConfig) {
  return {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@',
      dateDisabled: '&',
      customClass: '&'
    },
    link: function(scope, element, attrs, ngModel) {
      var dateFormat,
          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;

      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

      scope.getText = function( key ) {
        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
      };

      var isHtml5DateInput = false;
      if (datepickerPopupConfig.html5Types[attrs.type]) {
        dateFormat = datepickerPopupConfig.html5Types[attrs.type];
        isHtml5DateInput = true;
      } else {
        dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
        attrs.$observe('datepickerPopup', function(value, oldValue) {
            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
            // Invalidate the $modelValue to ensure that formatters re-run
            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
            if (newDateFormat !== dateFormat) {
              dateFormat = newDateFormat;
              ngModel.$modelValue = null;

              if (!dateFormat) {
                throw new Error('datepickerPopup must have a date format specified.');
              }
            }
        });
      }

      if (!dateFormat) {
        throw new Error('datepickerPopup must have a date format specified.');
      }

      if (isHtml5DateInput && attrs.datepickerPopup) {
        throw new Error('HTML5 date input types do not support custom formats.');
      }

      // popup element used to display calendar
      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
      popupEl.attr({
        'ng-model': 'date',
        'ng-change': 'dateSelection()'
      });

      function cameltoDash( string ){
        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
      }

      // datepicker element
      var datepickerEl = angular.element(popupEl.children()[0]);
      if (isHtml5DateInput) {
        if (attrs.type == 'month') {
          datepickerEl.attr('datepicker-mode', '"month"');
          datepickerEl.attr('min-mode', 'month');
        }
      }

      if ( attrs.datepickerOptions ) {
        var options = scope.$parent.$eval(attrs.datepickerOptions);
        if(options.initDate) {
          scope.initDate = options.initDate;
          datepickerEl.attr( 'init-date', 'initDate' );
          delete options.initDate;
        }
        angular.forEach(options, function( value, option ) {
          datepickerEl.attr( cameltoDash(option), value );
        });
      }

      scope.watchData = {};
      angular.forEach(['minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function( key ) {
        if ( attrs[key] ) {
          var getAttribute = $parse(attrs[key]);
          scope.$parent.$watch(getAttribute, function(value){
            scope.watchData[key] = value;
          });
          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

          // Propagate changes from datepicker to outside
          if ( key === 'datepickerMode' ) {
            var setAttribute = getAttribute.assign;
            scope.$watch('watchData.' + key, function(value, oldvalue) {
              if ( value !== oldvalue ) {
                setAttribute(scope.$parent, value);
              }
            });
          }
        }
      });
      if (attrs.dateDisabled) {
        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
      }

      if (attrs.showWeeks) {
        datepickerEl.attr('show-weeks', attrs.showWeeks);
      }

      if (attrs.customClass){
        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
      }

      function parseDate(viewValue) {
        if (angular.isNumber(viewValue)) {
          // presumably timestamp to date object
          viewValue = new Date(viewValue);
        }

        if (!viewValue) {
          return null;
        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          return viewValue;
        } else if (angular.isString(viewValue)) {
          var date = dateParser.parse(viewValue, dateFormat, scope.date) || new Date(viewValue);
          if (isNaN(date)) {
            return undefined;
          } else {
            return date;
          }
        } else {
          return undefined;
        }
      }

      function validator(modelValue, viewValue) {
        var value = modelValue || viewValue;
        if (angular.isNumber(value)) {
          value = new Date(value);
        }
        if (!value) {
          return true;
        } else if (angular.isDate(value) && !isNaN(value)) {
          return true;
        } else if (angular.isString(value)) {
          var date = dateParser.parse(value, dateFormat) || new Date(value);
          return !isNaN(date);
        } else {
          return false;
        }
      }

      if (!isHtml5DateInput) {
        // Internal API to maintain the correct ng-invalid-[key] class
        ngModel.$$parserName = 'date';
        ngModel.$validators.date = validator;
        ngModel.$parsers.unshift(parseDate);
        ngModel.$formatters.push(function (value) {
          scope.date = value;
          return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
        });
      }
      else {
        ngModel.$formatters.push(function (value) {
          scope.date = value;
          return value;
        });
      }

      // Inner change
      scope.dateSelection = function(dt) {
        if (angular.isDefined(dt)) {
          scope.date = dt;
        }
        var date = scope.date ? dateFilter(scope.date, dateFormat) : '';
        element.val(date);
        ngModel.$setViewValue(date);

        if ( closeOnDateSelection ) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      // Detect changes in the view from the text box
      ngModel.$viewChangeListeners.push(function () {
        scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date) || new Date(ngModel.$viewValue);
      });

      var documentClickBind = function(event) {
        if (scope.isOpen && event.target !== element[0]) {
          scope.$apply(function() {
            scope.isOpen = false;
          });
        }
      };

      var keydown = function(evt, noApply) {
        scope.keydown(evt);
      };
      element.bind('keydown', keydown);

      scope.keydown = function(evt) {
        if (evt.which === 27) {
          evt.preventDefault();
          if (scope.isOpen) {
            evt.stopPropagation();
          }
          scope.close();
        } else if (evt.which === 40 && !scope.isOpen) {
          scope.isOpen = true;
        }
      };

      scope.$watch('isOpen', function(value) {
        if (value) {
          scope.$broadcast('datepicker.focus');
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top = scope.position.top + element.prop('offsetHeight');

          $document.bind('click', documentClickBind);
        } else {
          $document.unbind('click', documentClickBind);
        }
      });

      scope.select = function( date ) {
        if (date === 'today') {
          var today = new Date();
          if (angular.isDate(scope.date)) {
            date = new Date(scope.date);
            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
          } else {
            date = new Date(today.setHours(0, 0, 0, 0));
          }
        }
        scope.dateSelection( date );
      };

      scope.close = function() {
        scope.isOpen = false;
        element[0].focus();
      };

      var $popup = $compile(popupEl)(scope);
      // Prevent jQuery cache memory leak (template is now redundant after linking)
      popupEl.remove();

      if ( appendToBody ) {
        $document.find('body').append($popup);
      } else {
        element.after($popup);
      }

      scope.$on('$destroy', function() {
        $popup.remove();
        element.unbind('keydown', keydown);
        $document.unbind('click', documentClickBind);
      });
    }
  };
}])

.directive('datepickerPopupWrap', function() {
  return {
    restrict:'EA',
    replace: true,
    transclude: true,
    templateUrl: '/app/directives/ui-bootstrap/datepicker/popup.html',
    link:function (scope, element, attrs) {
      element.bind('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
      });
    }
  };
});

// jscs:disable
// jshint ignore:start

angular.module('ui.bootstrap.dropdown', [])

.constant('dropdownConfig', {
  openClass: 'open'
})

.service('dropdownService', ['$document', '$rootScope', function($document, $rootScope) {
  var openScope = null;

  this.open = function( dropdownScope ) {
    if ( !openScope ) {
      $document.bind('click', closeDropdown);
      $document.bind('keydown', escapeKeyBind);
    }

    if ( openScope && openScope !== dropdownScope ) {
        openScope.isOpen = false;
    }

    openScope = dropdownScope;
  };

  this.close = function( dropdownScope ) {
    if ( openScope === dropdownScope ) {
      openScope = null;
      $document.unbind('click', closeDropdown);
      $document.unbind('keydown', escapeKeyBind);
    }
  };

  var closeDropdown = function( evt ) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) { return; }

    if( evt && openScope.getAutoClose() === 'disabled' )  { return ; }

    var toggleElement = openScope.getToggleElement();
    if ( evt && toggleElement && toggleElement[0].contains(evt.target) ) {
        return;
    }

    var $element = openScope.getElement();
    if( evt && openScope.getAutoClose() === 'outsideClick' && $element && $element[0].contains(evt.target) ) {
      return;
    }

    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  var escapeKeyBind = function( evt ) {
    if ( evt.which === 27 ) {
      openScope.focusToggleElement();
      closeDropdown();
    }
  };
}])

.controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', '$position', '$document', function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate, $position, $document) {
  var self = this,
      scope = $scope.$new(), // create a child scope so we are not polluting original one
      openClass = dropdownConfig.openClass,
      getIsOpen,
      setIsOpen = angular.noop,
      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
      appendToBody = false;

  this.init = function( element ) {
    self.$element = element;

    if ( $attrs.isOpen ) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);

    if ( appendToBody && self.dropdownMenu ) {
      $document.find('body').append( self.dropdownMenu );
      element.on('$destroy', function handleDestroyEvent() {
        self.dropdownMenu.remove();
      });
    }
  };

  this.toggle = function( open ) {
    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return self.$element;
  };

  scope.focusToggleElement = function() {
    if ( self.toggleElement ) {
      self.toggleElement[0].focus();
    }
  };

  scope.$watch('isOpen', function( isOpen, wasOpen ) {
    if ( appendToBody && self.dropdownMenu ) {
      var pos = $position.positionElements(self.$element, self.dropdownMenu, 'bottom-left', true);
      self.dropdownMenu.css({
        top: pos.top + 'px',
        left: pos.left + 'px',
        display: isOpen ? 'block' : 'none'
      });
    }

    $animate[isOpen ? 'addClass' : 'removeClass'](self.$element, openClass);

    if ( isOpen ) {
      scope.focusToggleElement();
      dropdownService.open( scope );
    } else {
      dropdownService.close( scope );
    }

    setIsOpen($scope, isOpen);
    if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
      toggleInvoker($scope, { open: !!isOpen });
    }
  });

  $scope.$on('$locationChangeSuccess', function() {
    scope.isOpen = false;
  });

  $scope.$on('$destroy', function() {
    scope.$destroy();
  });
}])

.directive('dropdown', function() {
  return {
    controller: 'DropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init( element );
    }
  };
})

.directive('dropdownMenu', function() {
  return {
    restrict: 'AC',
    require: '?^dropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if ( !dropdownCtrl ) {
        return;
      }
      dropdownCtrl.dropdownMenu = element;
    }
  };
})

.directive('dropdownToggle', function() {
  return {
    require: '?^dropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if ( !dropdownCtrl ) {
        return;
      }

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if ( !element.hasClass('disabled') && !attrs.disabled ) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function( isOpen ) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});

'use strict';

app.directive('modalTransclude', function () {
  return {
    link: function ($scope, $element) {
      $element.on('touchend', function (event) {
        event.stopPropagation();
      });
    }
  };
});

// jscs:disable
// jshint ignore:start

angular.module('ui.bootstrap.modal', [])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function () {
    return {
      createNew: function () {
        var stack = [];

        return {
          add: function (key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function (key) {
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function () {
            return stack[stack.length - 1];
          },
          remove: function (key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function () {
            return stack.splice(stack.length - 1, 1)[0];
          },
          length: function () {
            return stack.length;
          }
        };
      }
    };
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('modalBackdrop', ['$timeout', function ($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      templateUrl: '/app/directives/ui-bootstrap/modal/backdrop.html',
      compile: function (tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      scope.animate = false;

      //trigger CSS transitions
      $timeout(function () {
        scope.animate = true;
      });
    }
  }])

  .directive('modalWindow', ['$modalStack', '$q', function ($modalStack, $q) {
    return {
      restrict: 'EA',
      scope: {
        index: '@',
        animate: '='
      },
      replace: true,
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || '/app/directives/ui-bootstrap/modal/window.html';
      },
      link: function (scope, element, attrs) {
        element.addClass(attrs.windowClass || '');
        scope.size = attrs.size;

        scope.close = function (evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop && modal.value.backdrop != 'static' && (evt.target === evt.currentTarget)) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is render.
        var modalRenderDeferObj = $q.defer();
        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
        attrs.$observe('modalRender', function (value) {
          if (value == 'true') {
            modalRenderDeferObj.resolve();
          }
        });

        modalRenderDeferObj.promise.then(function () {
          // trigger CSS transitions
          scope.animate = true;

          var inputsWithAutofocus = element[0].querySelectorAll('[autofocus]');
          /**
           * Auto-focusing of a freshly-opened modal element causes any child elements
           * with the autofocus attribute to lose focus. This is an issue on touch
           * based devices which will show and then hide the onscreen keyboard.
           * Attempts to refocus the autofocus element via JavaScript will not reopen
           * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
           * the modal element if the modal does not contain an autofocus element.
           */
          if (inputsWithAutofocus.length) {
            inputsWithAutofocus[0].focus();
          } else {
            element[0].focus();
          }

          // Notify {@link $modalStack} that modal is rendered.
          var modal = $modalStack.getTop();
          if (modal) {
            $modalStack.modalRendered(modal.key);
          }
        });
      }
    };
  }])

  .directive('modalAnimationClass', [
    function () {
      return {
        compile: function (tElement, tAttrs) {
          if (tAttrs.modalAnimation) {
            tElement.addClass(tAttrs.modalAnimationClass);
          }
        }
      };
    }])

  .directive('modalTransclude', function () {
    return {
      link: function($scope, $element, $attrs, controller, $transclude) {
        $transclude($scope.$parent, function(clone) {
          $element.empty();
          $element.append(clone);
        });
      }
    };
  })

  .factory('$modalStack', ['$animate', '$timeout', '$document', '$compile', '$rootScope', '$$stackedMap',
    function ($animate, $timeout, $document, $compile, $rootScope, $$stackedMap) {

      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var $modalStack = {};

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex){
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance) {

        var body = $document.find('body').eq(0);
        var modalWindow = openedWindows.get(modalInstance).value;

        //clean up the stack
        openedWindows.remove(modalInstance);

        //remove window DOM element
        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
          checkRemoveBackdrop();
        });
      }

      function checkRemoveBackdrop() {
          //remove backdrop if no longer needed
          if (backdropDomEl && backdropIndex() == -1) {
            var backdropScopeRef = backdropScope;
            removeAfterAnimate(backdropDomEl, backdropScope, function () {
              backdropScopeRef = null;
            });
            backdropDomEl = undefined;
            backdropScope = undefined;
          }
      }

      function removeAfterAnimate(domEl, scope, done) {
        // Closing animation
        scope.animate = false;

        if (domEl.attr('modal-animation') && $animate.enabled()) {
          // transition out
          domEl.one('$animate:close', function closeFn() {
            $rootScope.$evalAsync(afterAnimating);
          });
        } else {
          // Ensure this call is async
          $timeout(afterAnimating);
        }

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          domEl.remove();
          scope.$destroy();
          if (done) {
            done();
          }
        }
      }

      $document.bind('keydown', function (evt) {
        var modal;

        if (evt.which === 27) {
          modal = openedWindows.top();
          if (modal && modal.value.keyboard) {
            evt.preventDefault();
            $rootScope.$apply(function () {
              $modalStack.dismiss(modal.key, 'escape key press');
            });
          }
        }
      });

      $modalStack.open = function (modalInstance, modal) {

        var modalOpener = $document[0].activeElement;

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard
        });

        var body = $document.find('body').eq(0),
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.index = currBackdropIndex;
          var angularBackgroundDomEl = angular.element('<div modal-backdrop="modal-backdrop"></div>');
          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
          if (modal.animation) {
            angularBackgroundDomEl.attr('modal-animation', 'true');
          }
          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
          body.append(backdropDomEl);
        }

        var angularDomEl = angular.element('<div modal-window="modal-window"></div>');
        angularDomEl.attr({
          'template-url': modal.windowTemplateUrl,
          'window-class': modal.windowClass,
          'size': modal.size,
          'index': openedWindows.length() - 1,
          'animate': 'animate'
        }).html(modal.content);
        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        var modalDomEl = $compile(angularDomEl)(modal.scope);
        openedWindows.top().value.modalDomEl = modalDomEl;
        openedWindows.top().value.modalOpener = modalOpener;
        body.append(modalDomEl);
        body.addClass(OPENED_MODAL_CLASS);
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
          return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      $modalStack.close = function (modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance);
          modalWindow.value.modalOpener.focus();
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismiss = function (modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance);
          modalWindow.value.modalOpener.focus();
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function (reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function () {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function (modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      return $modalStack;
    }])

  .provider('$modal', function () {

    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$injector', '$rootScope', '$q', '$templateRequest', '$controller', '$modalStack',
        function ($injector, $rootScope, $q, $templateRequest, $controller, $modalStack) {

          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl);
          }

          function getResolvePromises(resolves) {
            var promisesArr = [];
            angular.forEach(resolves, function (value) {
              if (angular.isFunction(value) || angular.isArray(value)) {
                promisesArr.push($q.when($injector.invoke(value)));
              }
            });
            return promisesArr;
          }

          $modal.open = function (modalOptions) {

            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};

            //verify options
            if (!modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of template or templateUrl options is required.');
            }

            var templateAndResolvePromise =
              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));


            templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {

              var modalScope = (modalOptions.scope || $rootScope).$new();
              modalScope.$close = modalInstance.close;
              modalScope.$dismiss = modalInstance.dismiss;

              var ctrlInstance, ctrlLocals = {};
              var resolveIter = 1;

              //controllers
              if (modalOptions.controller) {
                ctrlLocals.$scope = modalScope;
                ctrlLocals.$modalInstance = modalInstance;
                angular.forEach(modalOptions.resolve, function (value, key) {
                  ctrlLocals[key] = tplAndVars[resolveIter++];
                });

                ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                if (modalOptions.controllerAs) {
                  modalScope[modalOptions.controllerAs] = ctrlInstance;
                }
              }

              $modalStack.open(modalInstance, {
                scope: modalScope,
                deferred: modalResultDeferred,
                renderDeferred: modalRenderDeferred,
                content: tplAndVars[0],
                animation: modalOptions.animation,
                backdrop: modalOptions.backdrop,
                keyboard: modalOptions.keyboard,
                backdropClass: modalOptions.backdropClass,
                windowClass: modalOptions.windowClass,
                windowTemplateUrl: modalOptions.windowTemplateUrl,
                size: modalOptions.size
              });

            }, function resolveError(reason) {
              modalResultDeferred.reject(reason);
            });

            templateAndResolvePromise.then(function () {
              modalOpenedDeferred.resolve(true);
            }, function (reason) {
              modalOpenedDeferred.reject(reason);
            });

            return modalInstance;
          };

          return $modal;
        }]
    };

    return $modalProvider;
  });

// jscs:disable
// jshint ignore:start

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$position', ['$document', '$window', function ($document, $window) {

    function getStyle(el, cssprop) {
      if (el.currentStyle) { //IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, 'position') || 'static' ) === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function (element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function (element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function (element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function (hostEl, targetEl, positionStr, appendToBody) {

        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop('offsetWidth');
        targetElHeight = targetEl.prop('offsetHeight');

        var shiftWidth = {
          center: function () {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function () {
            return hostElPos.left;
          },
          right: function () {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function () {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function () {
            return hostElPos.top;
          },
          bottom: function () {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case 'right':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case 'left':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case 'bottom':
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);

// jscs:disable
// jshint ignore:start

angular.module('ui.bootstrap.transition', [])

/**
 * $transition service provides a consistent interface to trigger CSS 3 transitions and to be informed when they complete.
 * @param  {DOMElement} element  The DOMElement that will be animated.
 * @param  {string|object|function} trigger  The thing that will cause the transition to start:
 *   - As a string, it represents the css class to be added to the element.
 *   - As an object, it represents a hash of style attributes to be applied to the element.
 *   - As a function, it represents a function to be called that will cause the transition to occur.
 * @return {Promise}  A promise that is resolved when the transition finishes.
 */
.factory('$transition', ['$q', '$timeout', '$rootScope', function($q, $timeout, $rootScope) {

  var $transition = function(element, trigger, options) {
    options = options || {};
    var deferred = $q.defer();
    var endEventName = $transition[options.animation ? 'animationEndEventName' : 'transitionEndEventName'];

    var transitionEndHandler = function(event) {
      $rootScope.$apply(function() {
        element.unbind(endEventName, transitionEndHandler);
        deferred.resolve(element);
      });
    };

    if (endEventName) {
      element.bind(endEventName, transitionEndHandler);
    }

    // Wrap in a timeout to allow the browser time to update the DOM before the transition is to occur
    $timeout(function() {
      if ( angular.isString(trigger) ) {
        element.addClass(trigger);
      } else if ( angular.isFunction(trigger) ) {
        trigger(element);
      } else if ( angular.isObject(trigger) ) {
        element.css(trigger);
      }
      //If browser does not support transitions, instantly resolve
      if ( !endEventName ) {
        deferred.resolve(element);
      }
    });

    // Add our custom cancel function to the promise that is returned
    // We can call this if we are about to run a new transition, which we know will prevent this transition from ending,
    // i.e. it will therefore never raise a transitionEnd event for that transition
    deferred.promise.cancel = function() {
      if ( endEventName ) {
        element.unbind(endEventName, transitionEndHandler);
      }
      deferred.reject('Transition cancelled');
    };

    return deferred.promise;
  };

  // Work out the name of the transitionEnd event
  var transElement = document.createElement('trans');
  var transitionEndEventNames = {
    'WebkitTransition': 'webkitTransitionEnd',
    'MozTransition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'transition': 'transitionend'
  };
  var animationEndEventNames = {
    'WebkitTransition': 'webkitAnimationEnd',
    'MozTransition': 'animationend',
    'OTransition': 'oAnimationEnd',
    'transition': 'animationend'
  };
  function findEndEventName(endEventNames) {
    for (var name in endEventNames){
      if (transElement.style[name] !== undefined) {
        return endEventNames[name];
      }
    }
  }
  $transition.transitionEndEventName = findEndEventName(transitionEndEventNames);
  $transition.animationEndEventName = findEndEventName(animationEndEventNames);
  return $transition;
}]);

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.congratulations', {
    url: '/congratulations',
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/congratulations/congratulations.html',
        controller: function ($scope, $state, Api, instance, module) {
          $scope.module = module;
          Api.track('module.congratulations', 'view');

          var moduleIndex = _.findIndex(instance.modules, { _id: module._id });
          var nextModule = (moduleIndex >= 0) ? instance.modules[moduleIndex + 1] : false;
          var redirect = function () {
            if (nextModule) {
              $state.go('instance.app.module', { moduleId: nextModule._id });
            } else {
              $state.go('instance.app.dashboard');
            }
          };

          $scope.next = function () {
            Api.track('module.congratulations', 'pass')
              .then(function () {
                if (module.survey) {
                  return $scope.$popup('survey');
                }
              })
              .finally(redirect);
          };
        }
      }
    }
  });

});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.carousel', {
    url: '/carousel/:lessonId',
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/carousel/carousel.html',
        controller: function ($scope, $stateParams, module) {
          $scope.module = module;
          $scope.current = Math.max(0, _.findIndex(module.lessons, { _id: $stateParams.lessonId }));
        }
      }
    }
  });

});

'use strict';

app.directive('rmLessonsCarousel', function ($window, $swipe, $timeout, $animate, $animateCss) {
  return {
    scope: {
      current: '=rmLessonsCarousel'
    },
    require: 'rmLessonsCarousel',
    controller: function () {},
    link: function (scope, element, attrs, carousel) {

      var width;
      var items = [];
      var getWindowWidth = function () {
        width = $window.document.documentElement.offsetWidth - 30;
      };
      var setElementWidth = function (elem) {
        elem.css({ width: width });
      };
      getWindowWidth();
      var resize = function () {
        getWindowWidth();
        items.forEach(setElementWidth);
        move();
      };
      var $$window = angular.element($window);
      $$window.on('resize', resize);
      scope.$on('$destroy', function () {
        $$window.off('resize', resize);
      });
      carousel.item = function (elem) {
        items.push(elem);
        setElementWidth(elem);
      };

      var startCoords, startTime, canceled;
      var shift = function (delta) {
        return scope.current * width * (-1) + (delta || 0);
      };
      var move = function (delta) {
        element.css({ left: shift(delta) + 'px' });
      };
      var animate = function () {
        $animateCss(element, {
          to: { left: shift() + 'px' },
          duration: 0.2,
          easing: 'ease'
        }).start().done($timeout);
      };

      $swipe.bind(element.parent(), {
        start: function (coords) {
          startCoords = coords;
          startTime = Date.now();
          canceled = false;
        },
        cancel: function () {
          canceled = true;
        },
        move: function (coords) {
          move(coords.x - startCoords.x);
        },
        end: function (coords) {
          if (canceled) { return; }
          var delta = Math.abs(coords.x - startCoords.x);
          var time = Date.now() - startTime;
          var dir = coords.x > startCoords.x > 0 ? -1 : 1;
          if (delta > 130 || (delta > 40 && time < 200)) {
            scope.current = Math.max(0, Math.min(scope.current + dir, items.length - 1));
          }
          animate();
        }
      });

      move();
    }
  };
});

app.directive('rmLessonsCarouselItem', function () {
  return {
    require: '^rmLessonsCarousel',
    link: function (scope, element, attrs, carousel) {
      carousel.item(element);
    }
  };
});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.lesson', {
    url: '/lesson/:lessonId',
    resolve: {
      lesson: function (module, $stateParams, $q) {
        return _.find(module.lessons, { _id: $stateParams.lessonId }) || $q.reject({ status: 404 });
      }
    },
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/lesson/lesson.html',
        controller: function ($scope, $state, $viewport, module, lesson, instance, rmGuide) {
          $scope.module = module;
          $scope.lesson = lesson;
          if ($state.is('instance.app.module.lesson')) {
            $state.go('.introduction');
          }
        }
      }
    }
  });

});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.quiz', {
    url: '/quizzes/:quizType',
    resolve: {
      quiz: function ($q, $stateParams, module) {
        return module.quizzes[$stateParams.quizType] || $q.reject({ status: 404 });
      }
    },
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/quiz/quiz.html',
        controller: function ($scope, $state, Api, module, quiz) {
          $scope.module = module;
          $scope.quiz = quiz;

          Api.track('module.quiz', 'view');

          $scope.current = 0;
          $scope.question = quiz.questions[$scope.current];

          $scope.prev = function () {
            if ($scope.current === 0) {
              $state.go('^', {}, { reload: true });
            } else {
              $scope.current--;
              $scope.question = quiz.questions[$scope.current];
            }
          };

          $scope.next = function () {
            if ($scope.question.response) {
              if ($scope.quiz.passed) {
                //This strange logic is described in the doc block in $scope.reply()
                Api.track('module.quiz.question', 'pass', { questionId: $scope.question._id }, { answerId: $scope.question.response });
              }
              if ($scope.current === quiz.questions.length - 1) {
                quiz.answered = _.map(quiz.questions, function (q) {
                  return _.find(q.answers, { _id: q.response });
                });
                $state.go('.results');
              } else {
                $scope.current++;
                $scope.question = quiz.questions[$scope.current];
              }
            }
          };

          $scope.reply = function (answer) {
            $scope.question.response = answer._id;
            if (!$scope.quiz.passed) {
              /**
               * When user reviews the completed quiz and changes the answer >> Don't take him to the next question automatically.
               * Let him see his new choice and click Next.
               * If he doesn't click Next and just closes the view don't save this new data.
               */
              Api.track('module.quiz.question', 'pass', { questionId: $scope.question._id }, { answerId: answer._id });
              $scope.next();
            }
          };

        }
      }
    }
  });

  $stateProvider.state('instance.app.module.quiz.results', {
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/quiz/quizResults.html',
        controller: function ($scope, $state, $stateParams, Api, module, quiz) {
          $scope.module = module;
          $scope.quiz = quiz;
          $scope.quizType = $stateParams.quizType;
          $scope.score = _(quiz.answered).filter('value', 1).size();
          $scope.maxScore = quiz.questions.length;
          $scope.result = _.find(quiz.response.responses, function (response) {
            return response.values.min <= $scope.score && response.values.max >= $scope.score;
          });
          var incorrectAnswers = _.filter(quiz.answered, 'value', 0);
          $scope.incorrectQuestions = _(quiz.questions).filter(function (q, idx) {
            var intersection = _.intersection(_.map(q.answers, '_id'), _.map(incorrectAnswers, '_id'));
            if (intersection.length && q.lesson) {
              q.index = idx;
              var lesson = _.find(module.lessons, {_id: q.lesson});
              q.lessonName = 'Lesson ' + lesson.index + ': ' + lesson.name;
              q.byteName = _.find(lesson.learningBytes, {_id: q.byte}).name;
              q.correctAnswer = _.find(q.answers, {value: 1});
              return q;
            }
            return false;
          }).value();
          $scope.userAnswers = quiz.answered;

          Api.track('module.quiz', 'pass', {}, { result: $scope.score / $scope.maxScore });

          $scope.continue = function () {
            if ($scope.quizType == 'post') {
              $state.go('^.^.recap', {}, { reload: true });
            } else {
              $state.go('^.^', { expandedLessonId: module.lessons[0]._id }, { reload: true });
            }
          };
        }
      }
    }
  });
});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.recap', {
    url: '/recap',
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/recap/recap.html',
        controller: function ($scope, $state, Api, module) {
          $scope.module = module;
          Api.track('module.recap', 'view');
          $scope.next = function () {
            Api.track('module.recap', 'pass').then(function () {
              $state.go('^.congratulations', {}, { reload: true });
            });
          };
        }
      }
    }
  });

});

'use strict';

// custom click handler to not prevent default
// on touch devices if href is defined
app.directive('rmClick', function () {
  return {
    scope: { action: '&rmClick' },
    link: function (scope, element) {
      element.on('click', function () {
        scope.$apply(scope.action);
      });
    }
  };
});

'use strict';

app.config(function ($popupProvider) {

  $popupProvider.define('survey', function () {
    return /*@ngInject*/ {
      windowClass: 'survey-modal',
      templateUrl: '/app/states/module/survey/survey.html'
    };
  });

});

'use strict';

app.config(function ($popupProvider) {
  $popupProvider.define('avatar', function (avatar) {
    return /*@ngInject*/ {
      backdrop: 'static',
      windowClass: 'avatar-modal-window',
      templateUrl: '/app/states/profile/avatar/avatar.html',
      controller: function ($scope, $q, $timeout, $preloader, $popup, S3Uploader) {

        var SIZE = 360;
        var DEFAULT = '/stubs/users/default.jpg';
        var ready = false;
        var $cropper;

        $scope.url = avatar.url || DEFAULT;
        $scope.zoom = { level: 100 };

        var zoomData = null;

        $scope.$watch('zoom.level', function (zoomLevel, old) {
          if (zoomLevel === old) { return; }
          var scale = 2 - zoomLevel / 100;
          var canvasData = $cropper.cropper('getCanvasData');
          $cropper.cropper('setCanvasData', {
            top: canvasData.top,
            left: canvasData.left,
            width: zoomData.width * scale,
            height: zoomData.height * scale
          });
        });

        $scope.zoomIn = function () {
          if (!ready) { return; }
          $scope.zoom.level = Math.min(100, $scope.zoom.level + 10);
        };

        $scope.zoomOut = function () {
          if (!ready) { return; }
          $scope.zoom.level = Math.max(0, $scope.zoom.level - 10);
        };

        $scope.fitToFrame = function () {
          if (!ready) { return; }
          $scope.zoom = { level: 100 };
        };

        $scope.rotate = function (side) {
          if (!ready) { return; }
          $cropper.cropper('rotate', side == 'left' ? -90 : 90);
          zoomData = {
            width: zoomData.height,
            height: zoomData.width
          };
        };

        $scope.remove = function () {
          if (!ready) { return; }
          $scope.url = DEFAULT;
          ready = false;
          $cropper.cropper('replace', $scope.url);
        };

        $scope.save = function () {
          if (!ready) { return; }
          $q.when()
            .then($preloader.show)
            .then(function () {
              return ($scope.url == DEFAULT) ? null : upload(getBlob());
            })
            .then($scope.$close)
            .finally($preloader.hide);
        };

        $timeout(function () {

          var $modal = $('.avatar-modal-window');

          $cropper = $modal.find('.cropper > img').cropper({
            autoCropArea: 1,
            aspectRatio: 1,
            guides: false,
            highlight: false,
            dragCrop: false,
            mouseWheelZoom: false,
            cropBoxMovable: false,
            cropBoxResizable: false,
            doubleClickToggle: false,
            built: function () {
              var params = { left: 0, top: 0, width: SIZE, height: SIZE };
              $cropper.cropper('zoom', SIZE);
              $cropper.cropper('setCropBoxData', params);
              $cropper.cropper('setCanvasData', params);
              zoomData = $cropper.cropper('getCanvasData');
              ready = true;
              $scope.$apply($scope.fitToFrame);
              $timeout(function () {
                $cropper.parent().css('visibility', '');
              }, 100, false);
            }
          });

          ready = false;
          $cropper.parent().css('visibility', 'hidden');
          $cropper.cropper('replace', $scope.url);

          $modal.find('.uploader').on('change', function () {
            ready = false;
            $cropper.parent().css('visibility', 'hidden');
            var input = this;
            $scope.url = input.value;
            blobToDataURI(input.files[0])
              .then(fixExif)
              .then(function (data) {
                $scope.url = data;
                $cropper.cropper('replace', $scope.url);
                input.value = null;
              });
          });

          $cropper.parent().on('touchend', function () {
            $(this).mouseup();
          });

        }, 200);

        function fixExif (data) {
          return $q(function (resolve) {
            var img = new Image();
            img.addEventListener('load', function () {
              EXIF.getData(img, function () {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                var width = img.width;
                var height = img.height;
                var orientation = img.exifdata.Orientation;
                canvas.width  = orientation < 5 ? width  : height;
                canvas.height = orientation < 5 ? height : width;
                switch (orientation) {
                  case 2: ctx.transform(-1,  0,  0,  1,  width,   0);      break;
                  case 3: ctx.transform(-1,  0,  0, -1,  width,   height); break;
                  case 4: ctx.transform( 1,  0,  0, -1,  0,       height); break;
                  case 5: ctx.transform( 0,  1,  1,  0,  0,       0);      break;
                  case 6: ctx.transform( 0,  1, -1,  0,  height,  0);      break;
                  case 7: ctx.transform( 0, -1, -1,  0,  height,  width);  break;
                  case 8: ctx.transform( 0, -1,  1,  0,  0,       width);  break;
                }
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL());
              });
            });
            img.src = data;
          });
        }

        function getBlob () {
          var params = { width: SIZE, height: SIZE };
          var mime = _.endsWith($scope.url, '.png') ? 'image/png' : 'image/jpeg';
          var data = $cropper.cropper('getCroppedCanvas', params).toDataURL(mime);
          return dataURItoBlob(data);
        }

        function upload (file) {
          var now = Date.now();
          var rand = S3Uploader.randomString(16);
          var ext = file.type == 'image/jpeg' ? 'jpg' : 'png';
          var name = now + '-' + rand + '.' + ext;
          var base;
          return $q.when()
            .then(function () {
              return S3Uploader.getUploadOptions('/api/v1/tools/s3/upload/' + name);
            })
            .then(function (opts) {
              base = 'https://' + opts.bucket + '.s3.amazonaws.com/';
              return S3Uploader.upload($scope.$new(), base, name, opts.acl, file.type, opts.key, opts.policy, opts.signature, file);
            })
            .then(function () {
              return base + name;
            });
        }

        function dataURItoBlob (dataURI) {
          var byteString;
          if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
          } else {
            byteString = unescape(dataURI.split(',')[1]);
          }
          var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
          var ia = new Uint8Array(byteString.length);
          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          return new Blob([ia], { type: mimeString });
        }

        function blobToDataURI (file) {
          return $q(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
              resolve(reader.result);
            };
            reader.onerror = function () {
              reject(reader.result);
            };
            reader.readAsDataURL(file);
          });
        }

      }
    };
  });
});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.lesson.byte', {
    url: '/byte/:byteId',
    resolve: {
      byte: function ($q, lesson, $stateParams) {
        return _.find(lesson.learningBytes, { _id: $stateParams.byteId }) || $q.reject({ status: 404 });
      }
    },
    templateUrl: '/app/states/module/lesson/byte/byte.html',
    controller: function ($scope, $state, $q, $stateParams, Api, module, lesson, byte, Documents, rmGuide) {
      $scope.showTutorial = _.get($scope.instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.byte.tutorial.id);
      };
      Api.track('module.lesson.byte', 'view');

      $scope.byte = byte;
      lesson.activeByte = byte;

      var fromPostQuiz = $scope.$root.fromPostQuiz;
      delete $scope.$root.fromPostQuiz;

      var minorLabels = {
        tips: 'Tips',
        related: 'Related',
        legends: 'Myths / Legends / Statistics',
        dosdonts: 'Dos & Don\'ts'
      };

      byte.majors.forEach(function (major) {
        // restore forms fields from history
        if (major.layout == 'form') {
          _.forEach(major.savedFormData, function (field) {
            if (!field) {
              //@TODO We need to fix missing _id field in old form data
              return;
            }
            var formField = _.find(major.data.form.fields, {_id: field._id});
            if (!formField) { return; }
            if (formField.type == 'checkbox') {
              _.forEach(formField.values, function (value) {
                value.selected = _.contains(field.selected, value._id);
              });
            } else {
              _.extend(formField, field);
            }
          });
        }
        //
        var inlineIndex = 1;
        major.minors.forEach(function (minor) {
          minor.label = minorLabels[minor.type];
          minor.href = major.type + '-' + minor.type;
          if (minor.type === 'inline') {
            minor.href += '-' + inlineIndex++;
          }
        });
      });

      var formToDoc = function (major) {
        var formData = major.data.form;
        var docName = module.name + ' Module → ' + lesson.name + ' → ' + byte.name + ' → ' + formData.fields[0].value;
        return {
          name: docName,
          sourceType: 'form',
          sourceParams: angular.extend({}, $stateParams, {
            instanceId: $scope.instance._id,
            major: major.type,
            byteName: byte.name
          }),
          form: formData
        };
      };

      $scope.next = function () {
        var documents = [];
        var meta = {};
        // save forms state to meta for history
        var majorForms = _.filter(byte.majors, { layout: 'form' });
        if (majorForms.length) {
          meta.forms = {};
          _.forEach(majorForms, function (major) {
            meta.forms[major.type] = _.map(major.data.form.fields, function (field) {
              var stash = {_id: field._id};
              if (field.type == 'checkbox') {
                stash.selected = _(field.values).filter('selected').pluck('_id').value();
              } else if (field.type == 'dropdown' || field.type == 'radio') {
                // adjust data for pdf creator
                field.value = field.selected && field.selected.text;
                _.forEach(field.values, function (val) { val.selected = false; });
                if (field.selected) { field.selected.selected = true; }
                //
                stash.default = _.indexOf(field.values, field.selected);
              } else if (field.type == 'date') {
                stash.default = 'custom';
                stash.date = field.value;
              } else {
                stash.default = field.value;
              }
              return stash;
            });
          });
          documents = _.map(majorForms, formToDoc);
        }

        $q.all([
          Api.track('module.lesson.byte', 'pass', {}, meta),
          //Don't call save docs if no docs were created on the page :)
          documents.length ? Documents.saveMultiple(documents) : true
        ])
          .then(function () {
            if (fromPostQuiz) {
              $state.go('^.^.quiz.results', { quizType: 'post' });
              return;
            }
            var next = lesson.learningBytes[byte.index];
            if (next) {
              $state.go('^.byte', { byteId: next._id }, { reload: true });
            } else {
              $state.go('^.recap', {}, { reload: true });
            }
          });
      };

      byte.majors.forEach(function (major) {
        if (major.layout == 'form' && !major.initialFormData) {
          major.initialFormData = [];
          angular.copy(major.data.form.fields, major.initialFormData);
        }
      });
      $scope.getFormData = function (major) {
        return major.data.form.fields;
      };
      $scope.resetFormData = function (major) {
        angular.copy(major.initialFormData, major.data.form.fields);
        $scope.byteForm.$setPristine();
      };
      $scope.atLeastOneSelected = function (values) {
        return _.filter(values, 'selected').length > 0;
      };
      $scope.today = function () {
        return new Date();
      };

    }
  });

});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.lesson.introduction', {
    url: '/introduction',
    templateUrl: '/app/states/module/lesson/introduction/introduction.html',
    controller: function ($scope, $state, Api, lesson, rmGuide) {
      $scope.showTutorial = _.get($scope.instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.lesson.tutorial.id);
      };
      lesson.activeByte = lesson.introduction;
      Api.track('module.lesson.introduction', 'view');
      $scope.next = function () {
        Api.track('module.lesson.introduction', 'pass').then(function () {
          if (lesson.learningBytes.length) {
            $state.go('^.byte', { byteId: lesson.learningBytes[0]._id }, { reload: true });
          } else {
            $state.go('^.recap', {}, { reload: true });
          }
        });
      };
    }
  });

});

'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.lesson.recap', {
    url: '/recap',
    templateUrl: '/app/states/module/lesson/recap/recap.html',
    controller: function ($scope, $state, $viewport, Api, module, lesson, rmGuide) {
      $scope.showTutorial = _.get($scope.instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.lesson.tutorial.id);
      };
      lesson.activeByte = null;
      Api.track('module.lesson.recap', 'view');
      $scope.next = function () {
        Api.track('module.lesson.recap', 'pass').then(function () {
          var next = module.lessons[lesson.index];
          if (next) {
            if ($viewport.isMobile) {
              $state.go('^.^.carousel', { lessonId: next._id }, { reload: true });
            } else {
              $state.go('^.^', { expandedLessonId: next._id }, { reload: true });
            }
          } else {
            if (module.quizzes.post && module.quizzes.post._id) {
              $state.go('^.^.quiz', { quizType: 'post' }, { reload: true });
            } else {
              $state.go('^.^.recap', {}, { reload: true });
            }
          }
        });
      };
    }
  });

});
}(window, angular));